import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: any; output: any };
  JSON: { input: any; output: any };
};

export type AssignDefaultConfigArgs = {
  configIds: Array<Scalars['String']['input']>;
  providerId: Scalars['String']['input'];
};

export type AuthPayload = {
  __typename?: 'AuthPayload';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export enum BackOfficePermissionsEnum {
  CanAddLanguage = 'CAN_ADD_LANGUAGE',
  CanAddTranslationKey = 'CAN_ADD_TRANSLATION_KEY',
  CanBlockUnblockUsers = 'CAN_BLOCK_UNBLOCK_USERS',
  CanDeleteBackofficeUsers = 'CAN_DELETE_BACKOFFICE_USERS',
  CanExportTransactions = 'CAN_EXPORT_TRANSACTIONS',
  CanExportTranslations = 'CAN_EXPORT_TRANSLATIONS',
  CanImportTranslations = 'CAN_IMPORT_TRANSLATIONS',
  CanManageAviatorRounds = 'CAN_MANAGE_AVIATOR_ROUNDS',
  CanManageBackofficePermissions = 'CAN_MANAGE_BACKOFFICE_PERMISSIONS',
  CanManageBackofficeRoles = 'CAN_MANAGE_BACKOFFICE_ROLES',
  CanManageBackofficeUsers = 'CAN_MANAGE_BACKOFFICE_USERS',
  CanManageFreebets = 'CAN_MANAGE_FREEBETS',
  CanManageFreebetsCampaigns = 'CAN_MANAGE_FREEBETS_CAMPAIGNS',
  CanManageLocalizations = 'CAN_MANAGE_LOCALIZATIONS',
  CanManageMinesRounds = 'CAN_MANAGE_MINES_ROUNDS',
  CanManagePermissions = 'CAN_MANAGE_PERMISSIONS',
  CanManageProviders = 'CAN_MANAGE_PROVIDERS',
  CanManageProviderConfigs = 'CAN_MANAGE_PROVIDER_CONFIGS',
  CanManageRaindropCampaigns = 'CAN_MANAGE_RAINDROP_CAMPAIGNS',
  CanManageRoundConfigs = 'CAN_MANAGE_ROUND_CONFIGS',
  CanManageRubberDuckRounds = 'CAN_MANAGE_RUBBER_DUCK_ROUNDS',
  CanManageTransactions = 'CAN_MANAGE_TRANSACTIONS',
  CanRetryFailedJobs = 'CAN_RETRY_FAILED_JOBS',
  CanRunTests = 'CAN_RUN_TESTS',
  CanViewAviatorAnalytics = 'CAN_VIEW_AVIATOR_ANALYTICS',
  CanViewAviatorRounds = 'CAN_VIEW_AVIATOR_ROUNDS',
  CanViewAviatorRoundTransactions = 'CAN_VIEW_AVIATOR_ROUND_TRANSACTIONS',
  CanViewBackofficePermissions = 'CAN_VIEW_BACKOFFICE_PERMISSIONS',
  CanViewBackofficeRoles = 'CAN_VIEW_BACKOFFICE_ROLES',
  CanViewBackofficeTasks = 'CAN_VIEW_BACKOFFICE_TASKS',
  CanViewBackofficeUsers = 'CAN_VIEW_BACKOFFICE_USERS',
  CanViewFailedSendCreditTransactions = 'CAN_VIEW_FAILED_SEND_CREDIT_TRANSACTIONS',
  CanViewFreebets = 'CAN_VIEW_FREEBETS',
  CanViewFreebetsCampaigns = 'CAN_VIEW_FREEBETS_CAMPAIGNS',
  CanViewFreebetsUsage = 'CAN_VIEW_FREEBETS_USAGE',
  CanViewFreebetsUsageLogs = 'CAN_VIEW_FREEBETS_USAGE_LOGS',
  CanViewLocalizations = 'CAN_VIEW_LOCALIZATIONS',
  CanViewMinesRounds = 'CAN_VIEW_MINES_ROUNDS',
  CanViewOngoingRound = 'CAN_VIEW_ONGOING_ROUND',
  CanViewProviders = 'CAN_VIEW_PROVIDERS',
  CanViewProviderConfigs = 'CAN_VIEW_PROVIDER_CONFIGS',
  CanViewProviderIgnoredRequests = 'CAN_VIEW_PROVIDER_IGNORED_REQUESTS',
  CanViewProviderPublicKey = 'CAN_VIEW_PROVIDER_PUBLIC_KEY',
  CanViewProviderTransactions = 'CAN_VIEW_PROVIDER_TRANSACTIONS',
  CanViewRaindropCampaigns = 'CAN_VIEW_RAINDROP_CAMPAIGNS',
  CanViewRoundConfigs = 'CAN_VIEW_ROUND_CONFIGS',
  CanViewRubberDuckRounds = 'CAN_VIEW_RUBBER_DUCK_ROUNDS',
  CanViewScheduledSendCreditTasks = 'CAN_VIEW_SCHEDULED_SEND_CREDIT_TASKS',
  CanViewTransactionExports = 'CAN_VIEW_TRANSACTION_EXPORTS',
}

export type BackOfficeSession = {
  __typename?: 'BackOfficeSession';
  provider?: Maybe<Provider>;
  session: Session;
};

export enum ClaimLimitPeriod {
  FiveMinutes = 'FIVE_MINUTES',
  FiveSeconds = 'FIVE_SECONDS',
  OneMinute = 'ONE_MINUTE',
  RainDuration = 'RAIN_DURATION',
  TenSeconds = 'TEN_SECONDS',
  ThirtySeconds = 'THIRTY_SECONDS',
}

export type CreateExportResponse = {
  __typename?: 'CreateExportResponse';
  exportId: Scalars['String']['output'];
  status: ExportStatus;
};

export type CreateProviderArgs = {
  apiUrl: Scalars['String']['input'];
  configId?: InputMaybe<Scalars['String']['input']>;
  creditOnDisconnect?: InputMaybe<Scalars['Boolean']['input']>;
  filterExternalProviderBets?: InputMaybe<Scalars['Boolean']['input']>;
  games: Array<Scalars['Int']['input']>;
  integrationType?: InputMaybe<ProviderIntegrationType>;
  isInternal: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  refundOnCreditFail: Scalars['Boolean']['input'];
  retryConfigId?: InputMaybe<Scalars['String']['input']>;
  retryScheduledSendCredit: Scalars['Boolean']['input'];
  status: ProviderStatus;
  syncRoundEnd: Scalars['Boolean']['input'];
};

export type CreateProviderConfigArgs = {
  betSuggestions: Array<Scalars['Float']['input']>;
  currency: Scalars['String']['input'];
  defaultAutoCashout: Scalars['Float']['input'];
  defaultBet: Scalars['Float']['input'];
  isRoundable: Scalars['Boolean']['input'];
  maxAutoCashout: Scalars['Float']['input'];
  maxBet: Scalars['Float']['input'];
  maxWin: Scalars['Float']['input'];
  minAutoCashout: Scalars['Float']['input'];
  minBet: Scalars['Float']['input'];
  providerId: Scalars['String']['input'];
};

export type CreateRaindropCampaignInput = {
  casinoId?: InputMaybe<Scalars['String']['input']>;
  claimDeadlineMinutes: Scalars['Int']['input'];
  claimLimitNumber?: InputMaybe<Scalars['Int']['input']>;
  claimLimitPeriod?: InputMaybe<ClaimLimitPeriod>;
  currency: Scalars['String']['input'];
  dayBudget?: InputMaybe<Scalars['Float']['input']>;
  distributionFrom: Scalars['Int']['input'];
  distributionTo: Scalars['Int']['input'];
  endDate: Scalars['DateTime']['input'];
  freebetValidityDate: Scalars['DateTime']['input'];
  freebetValue: Scalars['Float']['input'];
  freebetsPerRain: Scalars['Int']['input'];
  gameId?: Scalars['Int']['input'];
  minMultiplier: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  playerMinBalance?: InputMaybe<Scalars['Float']['input']>;
  playerMinWager?: InputMaybe<Scalars['Float']['input']>;
  providerId: Scalars['String']['input'];
  rainsPerDay: Scalars['Int']['input'];
  startDate: Scalars['DateTime']['input'];
  status?: InputMaybe<RaindropCampaignStatus>;
  totalBudget?: InputMaybe<Scalars['Float']['input']>;
  wagerPeriod?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateRaindropCampaignType = {
  __typename?: 'CreateRaindropCampaignType';
  id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CreateRetryConfigInput = {
  intervals: Array<Scalars['Float']['input']>;
  maxDuration?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
};

export type DateRangeInput = {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type ErrorsType = {
  __typename?: 'ErrorsType';
  err: Scalars['String']['output'];
};

export type ExchangeRate = {
  __typename?: 'ExchangeRate';
  /** Amount used to calculate the exchange rate */
  amount: Scalars['Float']['output'];
  /** Date-time when the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** The date associated with this exchange rate */
  date: Scalars['DateTime']['output'];
  /** Source currency code */
  from: Scalars['String']['output'];
  /** MongoDB ObjectId as a string */
  id: Scalars['ID']['output'];
  /** Exchange rate between source and target currencies */
  rate: Scalars['Float']['output'];
  /** Exchange rate between target and source currencies (reversed) */
  rateReversed: Scalars['Float']['output'];
  /** Link to Terms of Use or legal documentation */
  terms: Scalars['String']['output'];
  /** Target currency code */
  to: Scalars['String']['output'];
  /** Date-time when the document was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Maximum number of calls allowed per minute */
  xRateLimit: Scalars['Float']['output'];
  /** Number of calls remaining in the current minute */
  xRateLimitRemaining: Scalars['Float']['output'];
  /** UNIX timestamp when the per-minute rate limit resets */
  xRateLimitReset: Scalars['Float']['output'];
  /** Maximum number of requests allowed per day */
  xRateRequestLimit: Scalars['Float']['output'];
  /** Number of requests remaining for the current day */
  xRateRequestRemaining: Scalars['Float']['output'];
  /** UNIX timestamp when the daily request limit resets */
  xRateRequestReset: Scalars['Float']['output'];
  /** Request ID for this API call */
  xRequestId: Scalars['String']['output'];
};

export type ExportExcelInput = {
  dateRange: DateRangeInput;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  tableKey: TableKeyEnum;
};

export enum ExportStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Ready = 'READY',
}

export type ExportStatusResponse = {
  __typename?: 'ExportStatusResponse';
  exportId: Scalars['String']['output'];
  fileUrl?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export enum FreeBetAccessStatusEnum {
  Active = 'ACTIVE',
  Revoked = 'REVOKED',
}

export type FreeBetsCampaign = {
  __typename?: 'FreeBetsCampaign';
  _id: Scalars['String']['output'];
  campaignUniqueId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  providerId: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FreeBetsUsage = {
  __typename?: 'FreeBetsUsage';
  _id: Scalars['String']['output'];
  betNominal: Scalars['Float']['output'];
  campaignId: Scalars['String']['output'];
  count: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  minMultiplier: Scalars['Float']['output'];
  playerId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  requestId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalWin: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  usage: Scalars['Float']['output'];
  validityDate: Scalars['DateTime']['output'];
};

export type FreeBetsUsageLog = {
  __typename?: 'FreeBetsUsageLog';
  _id: Scalars['String']['output'];
  campaignId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  gameId: Scalars['Float']['output'];
  playerId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  roundId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  usageId: Scalars['String']['output'];
  win: Scalars['Float']['output'];
};

export type InputAssignRoleIds = {
  roleIds: Array<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type InputAssignRolePermissions = {
  permissions: Array<Scalars['String']['input']>;
  roleId: Scalars['String']['input'];
};

export type InputCreateLocalization = {
  betModeAuto?: InputMaybe<Scalars['String']['input']>;
  betModeManual?: InputMaybe<Scalars['String']['input']>;
  buttonCashout?: InputMaybe<Scalars['String']['input']>;
  buttonStartAutobet?: InputMaybe<Scalars['String']['input']>;
  buttonStartBet?: InputMaybe<Scalars['String']['input']>;
  componentCopyCopied?: InputMaybe<Scalars['String']['input']>;
  componentErrorConnectFailedDescription?: InputMaybe<Scalars['String']['input']>;
  componentErrorConnectFailedHome?: InputMaybe<Scalars['String']['input']>;
  componentErrorConnectFailedTitle?: InputMaybe<Scalars['String']['input']>;
  componentErrorDisconnectDescription?: InputMaybe<Scalars['String']['input']>;
  componentErrorDisconnectTitle?: InputMaybe<Scalars['String']['input']>;
  componentErrorGlobalAuthenticationDescription?: InputMaybe<Scalars['String']['input']>;
  componentErrorGlobalAuthenticationTitle?: InputMaybe<Scalars['String']['input']>;
  componentErrorGlobalDefaultDescription?: InputMaybe<Scalars['String']['input']>;
  componentErrorGlobalDefaultTitle?: InputMaybe<Scalars['String']['input']>;
  componentErrorGlobalGeneralDescription?: InputMaybe<Scalars['String']['input']>;
  componentErrorGlobalGeneralTitle?: InputMaybe<Scalars['String']['input']>;
  componentErrorGlobalHome?: InputMaybe<Scalars['String']['input']>;
  componentErrorGlobalSwitchedDescription?: InputMaybe<Scalars['String']['input']>;
  componentErrorGlobalSwitchedTitle?: InputMaybe<Scalars['String']['input']>;
  componentInputApply?: InputMaybe<Scalars['String']['input']>;
  formBetAmountLabel?: InputMaybe<Scalars['String']['input']>;
  formBetCountLabel?: InputMaybe<Scalars['String']['input']>;
  formGridSizeLabel?: InputMaybe<Scalars['String']['input']>;
  formMineCountLabel?: InputMaybe<Scalars['String']['input']>;
  formOnLossLabel?: InputMaybe<Scalars['String']['input']>;
  formOnLossOptionIncrease?: InputMaybe<Scalars['String']['input']>;
  formOnLossOptionReset?: InputMaybe<Scalars['String']['input']>;
  formOnWinLabel?: InputMaybe<Scalars['String']['input']>;
  formOnWinOptionIncrease?: InputMaybe<Scalars['String']['input']>;
  formOnWinOptionReset?: InputMaybe<Scalars['String']['input']>;
  formPayoutOnWinLabel?: InputMaybe<Scalars['String']['input']>;
  formStopOnLossLabel?: InputMaybe<Scalars['String']['input']>;
  formStopOnProfitLabel?: InputMaybe<Scalars['String']['input']>;
  gameAvatarSave?: InputMaybe<Scalars['String']['input']>;
  gameAvatarTitle?: InputMaybe<Scalars['String']['input']>;
  gameBetAutoBet?: InputMaybe<Scalars['String']['input']>;
  gameBetAutoCashOut?: InputMaybe<Scalars['String']['input']>;
  gameBetBet?: InputMaybe<Scalars['String']['input']>;
  gameBetCancel?: InputMaybe<Scalars['String']['input']>;
  gameBetCashOut?: InputMaybe<Scalars['String']['input']>;
  gameBetErrorBalance?: InputMaybe<Scalars['String']['input']>;
  gameBetErrorFreeBet?: InputMaybe<Scalars['String']['input']>;
  gameBetErrorGlobal?: InputMaybe<Scalars['String']['input']>;
  gameBetFreeBet?: InputMaybe<Scalars['String']['input']>;
  gameBetFreeBetCheck?: InputMaybe<Scalars['String']['input']>;
  gameBetWaiting?: InputMaybe<Scalars['String']['input']>;
  gameDisplayFlew?: InputMaybe<Scalars['String']['input']>;
  gameDisplayLoading?: InputMaybe<Scalars['String']['input']>;
  gameFooterProvablyFair?: InputMaybe<Scalars['String']['input']>;
  gameFreeBetsHistoryDate?: InputMaybe<Scalars['String']['input']>;
  gameFreeBetsHistoryGranted?: InputMaybe<Scalars['String']['input']>;
  gameFreeBetsHistoryMinCashout?: InputMaybe<Scalars['String']['input']>;
  gameFreeBetsTabActive?: InputMaybe<Scalars['String']['input']>;
  gameFreeBetsTabHistory?: InputMaybe<Scalars['String']['input']>;
  gameFreeBetsTableBet?: InputMaybe<Scalars['String']['input']>;
  gameFreeBetsTableCashout?: InputMaybe<Scalars['String']['input']>;
  gameFreeBetsTableCount?: InputMaybe<Scalars['String']['input']>;
  gameFreeBetsTableEmpty?: InputMaybe<Scalars['String']['input']>;
  gameFreeBetsTitle?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsClientDescription?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsClientLabel?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsCombinedDecimal?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsCombinedDescription?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsCombinedHex?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsCombinedLabel?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsCombinedResult?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsDate?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsPlayerSeed?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsPlayerTitle?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsProvablyFair?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsServerDescription?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsServerLabel?: InputMaybe<Scalars['String']['input']>;
  gameHistoryDetailsTitle?: InputMaybe<Scalars['String']['input']>;
  gameHistoryTitle?: InputMaybe<Scalars['String']['input']>;
  gameLimitsMax?: InputMaybe<Scalars['String']['input']>;
  gameLimitsMin?: InputMaybe<Scalars['String']['input']>;
  gameLimitsTitle?: InputMaybe<Scalars['String']['input']>;
  gameLimitsWin?: InputMaybe<Scalars['String']['input']>;
  gameMenuAnimation?: InputMaybe<Scalars['String']['input']>;
  gameMenuFreeBets?: InputMaybe<Scalars['String']['input']>;
  gameMenuHome?: InputMaybe<Scalars['String']['input']>;
  gameMenuLimits?: InputMaybe<Scalars['String']['input']>;
  gameMenuMusic?: InputMaybe<Scalars['String']['input']>;
  gameMenuMyBets?: InputMaybe<Scalars['String']['input']>;
  gameMenuRules?: InputMaybe<Scalars['String']['input']>;
  gameMenuSound?: InputMaybe<Scalars['String']['input']>;
  gameMyBetsTableEmpty?: InputMaybe<Scalars['String']['input']>;
  gameMyBetsTitle?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsMyBet?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsMyDate?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsMyEmpty?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsMyWin?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsRoundCurrentPrevious?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsRoundCurrentTotal?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsRoundPreviousPrevious?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsRoundPreviousTotal?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsRoundTableBet?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsRoundTableEmpty?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsRoundTablePlayer?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsRoundTableWin?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsTabCurrent?: InputMaybe<Scalars['String']['input']>;
  gamePlacedBetsTabMy?: InputMaybe<Scalars['String']['input']>;
  gameProvablyFairHowLongDescription?: InputMaybe<Scalars['String']['input']>;
  gameProvablyFairHowLongTitle?: InputMaybe<Scalars['String']['input']>;
  gameProvablyFairHowShortDescription?: InputMaybe<Scalars['String']['input']>;
  gameProvablyFairHowShortTitle?: InputMaybe<Scalars['String']['input']>;
  gameProvablyFairHowTitle?: InputMaybe<Scalars['String']['input']>;
  gameProvablyFairReliabilityDescription?: InputMaybe<Array<Scalars['String']['input']>>;
  gameProvablyFairReliabilityTitle?: InputMaybe<Scalars['String']['input']>;
  gameProvablyFairTitle?: InputMaybe<Scalars['String']['input']>;
  gameProvablyFairWhatDescription?: InputMaybe<Scalars['String']['input']>;
  gameProvablyFairWhatTitle?: InputMaybe<Scalars['String']['input']>;
  gameRulesAccordion0Description?: InputMaybe<Array<Scalars['String']['input']>>;
  gameRulesAccordion0Title?: InputMaybe<Scalars['String']['input']>;
  gameRulesAccordion1Description?: InputMaybe<Array<Scalars['String']['input']>>;
  gameRulesAccordion1Title?: InputMaybe<Scalars['String']['input']>;
  gameRulesAccordion2Description?: InputMaybe<Array<Scalars['String']['input']>>;
  gameRulesAccordion2Title?: InputMaybe<Scalars['String']['input']>;
  gameRulesAccordion3Description?: InputMaybe<Array<Scalars['String']['input']>>;
  gameRulesAccordion3Title?: InputMaybe<Scalars['String']['input']>;
  gameRulesAccordion4Description?: InputMaybe<Array<Scalars['String']['input']>>;
  gameRulesAccordion4Title?: InputMaybe<Scalars['String']['input']>;
  gameRulesAdditionalTitle?: InputMaybe<Scalars['String']['input']>;
  gameRulesHowDescription?: InputMaybe<Scalars['String']['input']>;
  gameRulesHowTitle?: InputMaybe<Scalars['String']['input']>;
  gameRulesSlider1?: InputMaybe<Scalars['String']['input']>;
  gameRulesSlider2?: InputMaybe<Scalars['String']['input']>;
  gameRulesTitle?: InputMaybe<Scalars['String']['input']>;
  gameRulesVideoDescription?: InputMaybe<Scalars['String']['input']>;
  gameRulesVideoTitle?: InputMaybe<Scalars['String']['input']>;
  gameWinSnackbarLabel?: InputMaybe<Scalars['String']['input']>;
  gameWinSnackbarWin?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  limitsMaxBet?: InputMaybe<Scalars['String']['input']>;
  limitsMaxWin?: InputMaybe<Scalars['String']['input']>;
  limitsMinBet?: InputMaybe<Scalars['String']['input']>;
  rulesText1?: InputMaybe<Scalars['String']['input']>;
  rulesText2?: InputMaybe<Scalars['String']['input']>;
  rulesText3?: InputMaybe<Scalars['String']['input']>;
  rulesText4?: InputMaybe<Scalars['String']['input']>;
  rulesText5?: InputMaybe<Scalars['String']['input']>;
  rulesTitle1?: InputMaybe<Scalars['String']['input']>;
  rulesTitle2?: InputMaybe<Scalars['String']['input']>;
  rulesTitle3?: InputMaybe<Scalars['String']['input']>;
  rulesTitle4?: InputMaybe<Scalars['String']['input']>;
  rulesTitle5?: InputMaybe<Scalars['String']['input']>;
  sectionLimitsTitle?: InputMaybe<Scalars['String']['input']>;
  sectionRulesTitle?: InputMaybe<Scalars['String']['input']>;
  tabMyBets?: InputMaybe<Scalars['String']['input']>;
  toggleAnimation?: InputMaybe<Scalars['String']['input']>;
  toggleDark?: InputMaybe<Scalars['String']['input']>;
  toggleMusic?: InputMaybe<Scalars['String']['input']>;
  toggleSound?: InputMaybe<Scalars['String']['input']>;
};

export type InputCreateRole = {
  description: Scalars['String']['input'];
  isEditable: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  permissions: Array<BackOfficePermissionsEnum>;
};

export type InputCreateUser = {
  email: Scalars['String']['input'];
  games: Array<Scalars['Int']['input']>;
  password: Scalars['String']['input'];
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerRgs?: InputMaybe<Array<InputProviderRgs>>;
  roleIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InputDeleteRole = {
  roleId: Scalars['String']['input'];
};

export type InputDeleteUserRole = {
  roleId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type InputFilterExchangeRates = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type InputFilterFreeBetUsageLogs = {
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxWin?: InputMaybe<Scalars['Float']['input']>;
  minWin?: InputMaybe<Scalars['Float']['input']>;
  playerId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  roundId?: InputMaybe<Scalars['String']['input']>;
  usageId?: InputMaybe<Scalars['String']['input']>;
};

export type InputFilterFreeBetsCampagins = {
  campaignUniqueId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<FreeBetAccessStatusEnum>;
};

export type InputFilterFreeBetsUsage = {
  campaignId?: InputMaybe<Scalars['String']['input']>;
  createdAtEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  freebetUsageLogId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxBetNominal?: InputMaybe<Scalars['Float']['input']>;
  maxCount?: InputMaybe<Scalars['Float']['input']>;
  maxMultiplier?: InputMaybe<Scalars['Float']['input']>;
  maxTotalWin?: InputMaybe<Scalars['Float']['input']>;
  maxUsage?: InputMaybe<Scalars['Float']['input']>;
  minBetNominal?: InputMaybe<Scalars['Float']['input']>;
  minCount?: InputMaybe<Scalars['Float']['input']>;
  minMultiplier?: InputMaybe<Scalars['Float']['input']>;
  minTotalWin?: InputMaybe<Scalars['Float']['input']>;
  minUsage?: InputMaybe<Scalars['Float']['input']>;
  playerId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  validityEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  validityStartDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type InputFilterIgnoredRequests = {
  createdAtEnd?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtStart?: InputMaybe<Scalars['DateTime']['input']>;
  gameId?: InputMaybe<Scalars['Float']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  playerId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  roundId?: InputMaybe<Scalars['String']['input']>;
};

export type InputFilterMinesRounds = {
  autoplay?: InputMaybe<Scalars['Boolean']['input']>;
  clientHash?: InputMaybe<Scalars['String']['input']>;
  completedEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  completedStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  gameId?: InputMaybe<Scalars['Int']['input']>;
  gridSize?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxBetAmount?: InputMaybe<Scalars['Float']['input']>;
  maxCurrentMultiplier?: InputMaybe<Scalars['Float']['input']>;
  maxTotalWinAmount?: InputMaybe<Scalars['Float']['input']>;
  minBetAmount?: InputMaybe<Scalars['Float']['input']>;
  minCurrentMultiplier?: InputMaybe<Scalars['Float']['input']>;
  minTotalWinAmount?: InputMaybe<Scalars['Float']['input']>;
  minesCount?: InputMaybe<Scalars['Int']['input']>;
  playerId?: InputMaybe<Scalars['String']['input']>;
  roundHash?: InputMaybe<Scalars['String']['input']>;
  roundId?: InputMaybe<Scalars['String']['input']>;
  serverHash?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type InputFilterProviderTransaction = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  gameId?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  maxAmount?: InputMaybe<Scalars['Float']['input']>;
  maxBalance?: InputMaybe<Scalars['Float']['input']>;
  maxMultiplier?: InputMaybe<Scalars['Float']['input']>;
  minAmount?: InputMaybe<Scalars['Float']['input']>;
  minBalance?: InputMaybe<Scalars['Float']['input']>;
  minMultiplier?: InputMaybe<Scalars['Float']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  playerId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  roundId?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type InputFilterRubberDuckRounds = {
  autoplay?: InputMaybe<Scalars['Boolean']['input']>;
  clientHash?: InputMaybe<Scalars['String']['input']>;
  completedEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  completedStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  createdStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  difficulty?: InputMaybe<Scalars['String']['input']>;
  gameId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  laneCount?: InputMaybe<Scalars['Int']['input']>;
  maxBetAmount?: InputMaybe<Scalars['Float']['input']>;
  maxCurrentMultiplier?: InputMaybe<Scalars['Float']['input']>;
  maxReachedLane?: InputMaybe<Scalars['Int']['input']>;
  maxTotalWinAmount?: InputMaybe<Scalars['Float']['input']>;
  minBetAmount?: InputMaybe<Scalars['Float']['input']>;
  minCurrentMultiplier?: InputMaybe<Scalars['Float']['input']>;
  minReachedLane?: InputMaybe<Scalars['Int']['input']>;
  minTotalWinAmount?: InputMaybe<Scalars['Float']['input']>;
  playerId?: InputMaybe<Scalars['String']['input']>;
  roundHash?: InputMaybe<Scalars['String']['input']>;
  roundId?: InputMaybe<Scalars['String']['input']>;
  serverHash?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type InputProviderFilter = {
  games?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<ProviderIntegrationType>;
  name?: InputMaybe<Scalars['String']['input']>;
  refundOnCreditFail?: InputMaybe<Scalars['Boolean']['input']>;
  retryScheduledSendCredit?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ProviderStatus>;
  syncRoundEnd?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputProviderRgs = {
  providerIds: Array<Scalars['String']['input']>;
  rgsId: Rgs;
};

export type InputRemoveRolePermission = {
  permission: Scalars['String']['input'];
  roleId: Scalars['String']['input'];
};

export type InputUpdateLocalization = {
  language: Scalars['String']['input'];
  localizationKey: Scalars['String']['input'];
  localizationValue: Scalars['String']['input'];
};

export type Localization = {
  __typename?: 'Localization';
  _id: Scalars['String']['output'];
  gameId: Scalars['Int']['output'];
  language: Scalars['String']['output'];
  translations: Scalars['String']['output'];
};

export type LocalizationObjectType = {
  __typename?: 'LocalizationObjectType';
  languages?: Maybe<Array<Scalars['String']['output']>>;
  translations: Scalars['String']['output'];
};

export type MinesAutobetConfig = {
  __typename?: 'MinesAutobetConfig';
  increaseOnLoss?: Maybe<Scalars['Float']['output']>;
  increaseOnWin?: Maybe<Scalars['Float']['output']>;
  numberOfBets?: Maybe<Scalars['Int']['output']>;
  payoutOnWin?: Maybe<Scalars['Float']['output']>;
  stopOnLoss?: Maybe<Scalars['Float']['output']>;
  stopOnProfit?: Maybe<Scalars['Float']['output']>;
};

export type MinesRevealedTile = {
  __typename?: 'MinesRevealedTile';
  mine: Scalars['Boolean']['output'];
  multiplier: Scalars['Float']['output'];
  tileNumber: Scalars['Int']['output'];
};

export type MinesRoundConfigType = {
  __typename?: 'MinesRoundConfigType';
  _id?: Maybe<Scalars['ID']['output']>;
  autobetConfig?: Maybe<MinesAutobetConfig>;
  autoplay: Scalars['Boolean']['output'];
  betAmount: Scalars['Float']['output'];
  clientHash: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency: Scalars['String']['output'];
  currentMultiplier: Scalars['Float']['output'];
  gameData?: Maybe<Scalars['JSON']['output']>;
  gameId: Scalars['Int']['output'];
  gridSize: Scalars['Int']['output'];
  maxWin?: Maybe<Scalars['Float']['output']>;
  minesCount: Scalars['Int']['output'];
  playerId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  revealedTiles: Array<MinesRevealedTile>;
  roundHash: Scalars['String']['output'];
  roundId: Scalars['String']['output'];
  serverHash: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalTiles: Array<MinesTotalTile>;
  totalWinAmount: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MinesTotalTile = {
  __typename?: 'MinesTotalTile';
  id: Scalars['ID']['output'];
  revealed: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addLocalizationKey: Scalars['Boolean']['output'];
  addNewLanguage?: Maybe<Scalars['Boolean']['output']>;
  addPermission: Scalars['Float']['output'];
  assignDefaultConfigs: Scalars['Float']['output'];
  assignRolePermissions: Scalars['Boolean']['output'];
  assignUserRolesIds: Scalars['Boolean']['output'];
  createLocalization: Scalars['Boolean']['output'];
  createLocalizationDefault: Localization;
  createProvider: Provider;
  createProviderConfig: ProviderConfig;
  createRaindropCampaign: CreateRaindropCampaignType;
  createRetryConfig: RetryConfig;
  createRole: Role;
  createUser: User;
  deleteProviderConfig: Scalars['Int']['output'];
  deleteProviderConfigId: Scalars['Int']['output'];
  deleteRole: Scalars['Int']['output'];
  deleteUserRole: Scalars['Int']['output'];
  exportTransactionsToExcel: CreateExportResponse;
  generateDefaultProviderConfigs: Scalars['Boolean']['output'];
  logout: Scalars['Boolean']['output'];
  refreshToken: AuthPayload;
  removeRolePermission: Scalars['Int']['output'];
  signIn: AuthPayload;
  testProvider: TestProviderResponseObjectType;
  updateLocalization: Scalars['Boolean']['output'];
  updateProvider: Scalars['Int']['output'];
  updateProviderConfig: Scalars['Int']['output'];
  updateProviderRetryConfigId: Scalars['Int']['output'];
};

export type MutationAddLocalizationKeyArgs = {
  input: InputUpdateLocalization;
};

export type MutationAddNewLanguageArgs = {
  newLanguage: Scalars['String']['input'];
};

export type MutationAddPermissionArgs = {
  permission: Scalars['String']['input'];
};

export type MutationAssignDefaultConfigsArgs = {
  input: AssignDefaultConfigArgs;
};

export type MutationAssignRolePermissionsArgs = {
  input: InputAssignRolePermissions;
};

export type MutationAssignUserRolesIdsArgs = {
  input: InputAssignRoleIds;
};

export type MutationCreateLocalizationArgs = {
  input: InputCreateLocalization;
};

export type MutationCreateLocalizationDefaultArgs = {
  language: Scalars['String']['input'];
};

export type MutationCreateProviderArgs = {
  input: CreateProviderArgs;
};

export type MutationCreateProviderConfigArgs = {
  input: CreateProviderConfigArgs;
};

export type MutationCreateRaindropCampaignArgs = {
  input: CreateRaindropCampaignInput;
};

export type MutationCreateRetryConfigArgs = {
  input: CreateRetryConfigInput;
};

export type MutationCreateRoleArgs = {
  input: InputCreateRole;
};

export type MutationCreateUserArgs = {
  input: InputCreateUser;
};

export type MutationDeleteProviderConfigArgs = {
  configId: Scalars['String']['input'];
};

export type MutationDeleteProviderConfigIdArgs = {
  providerId: Scalars['String']['input'];
};

export type MutationDeleteRoleArgs = {
  input: InputDeleteRole;
};

export type MutationDeleteUserRoleArgs = {
  input: InputDeleteUserRole;
};

export type MutationExportTransactionsToExcelArgs = {
  input: ExportExcelInput;
};

export type MutationGenerateDefaultProviderConfigsArgs = {
  providerId: Scalars['String']['input'];
};

export type MutationRefreshTokenArgs = {
  token: Scalars['String']['input'];
};

export type MutationRemoveRolePermissionArgs = {
  input: InputRemoveRolePermission;
};

export type MutationSignInArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type MutationTestProviderArgs = {
  testProviderInput: TestProvidersInput;
};

export type MutationUpdateLocalizationArgs = {
  input: InputUpdateLocalization;
};

export type MutationUpdateProviderArgs = {
  input: UpdateProviderArgs;
  providerId: Scalars['String']['input'];
};

export type MutationUpdateProviderConfigArgs = {
  configId: Scalars['String']['input'];
  input: UpdateProviderConfigArgs;
};

export type MutationUpdateProviderRetryConfigIdArgs = {
  providerId: Scalars['String']['input'];
  retryConfigId?: InputMaybe<Scalars['String']['input']>;
};

export type PaginatedFreeBets = {
  __typename?: 'PaginatedFreeBets';
  docs: Array<FreeBetsUsage>;
  limit: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
  skip?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
};

export type PaginatedFreeBetsCampaigns = {
  __typename?: 'PaginatedFreeBetsCampaigns';
  docs: Array<FreeBetsCampaign>;
  limit: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
  skip?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
};

export type PaginatedFreeBetsUsageLogs = {
  __typename?: 'PaginatedFreeBetsUsageLogs';
  docs: Array<FreeBetsUsageLog>;
  limit: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
  skip?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
};

export type PaginatedMinesRounds = {
  __typename?: 'PaginatedMinesRounds';
  docs: Array<MinesRoundConfigType>;
  limit: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
  skip?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
};

export type PaginatedProviderIgnoredRequests = {
  __typename?: 'PaginatedProviderIgnoredRequests';
  docs: Array<ProviderIgnoredRequests>;
  limit: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
  skip?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
};

export type PaginatedProviderTransactions = {
  __typename?: 'PaginatedProviderTransactions';
  docs: Array<ProviderTransaction>;
  limit: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
  skip?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
};

export type PaginatedRaindropCampaign = {
  __typename?: 'PaginatedRaindropCampaign';
  docs: Array<RaindropCampaignType>;
  limit: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
  skip?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
};

export type PaginatedRubberDuckRounds = {
  __typename?: 'PaginatedRubberDuckRounds';
  docs: Array<RubberDuckRoundConfigType>;
  limit: Scalars['Float']['output'];
  page: Scalars['Float']['output'];
  skip?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
};

export type PaginationInput = {
  limit?: Scalars['Float']['input'];
  page?: Scalars['Float']['input'];
};

export type Provider = {
  __typename?: 'Provider';
  apiUrl: Scalars['String']['output'];
  configId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creditOnDisconnect?: Maybe<Scalars['Boolean']['output']>;
  filterExternalProviderBets?: Maybe<Scalars['Boolean']['output']>;
  games: Array<Scalars['Int']['output']>;
  homePageUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  integrationType?: Maybe<ProviderIntegrationType>;
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  passPhrase: Scalars['String']['output'];
  privateKey: Scalars['String']['output'];
  publicKey: Scalars['String']['output'];
  refundOnCreditFail?: Maybe<Scalars['Boolean']['output']>;
  retryConfigId?: Maybe<Scalars['String']['output']>;
  retryScheduledSendCredit?: Maybe<Scalars['Boolean']['output']>;
  rgsId?: Maybe<Rgs>;
  status?: Maybe<ProviderStatus>;
  syncRoundEnd?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProviderConfig = {
  __typename?: 'ProviderConfig';
  betSuggestions: Array<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  defaultAutoCashout?: Maybe<Scalars['Float']['output']>;
  defaultBet: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isRoundable: Scalars['Boolean']['output'];
  maxAutoCashout?: Maybe<Scalars['Float']['output']>;
  maxBet: Scalars['Float']['output'];
  maxWin: Scalars['Float']['output'];
  minAutoCashout?: Maybe<Scalars['Float']['output']>;
  minBet: Scalars['Float']['output'];
  providerId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProviderConfigFilter = {
  currency?: InputMaybe<Scalars['String']['input']>;
  isRoundable?: InputMaybe<Scalars['Boolean']['input']>;
  maxBet?: InputMaybe<Scalars['Float']['input']>;
  maxWin?: InputMaybe<Scalars['Float']['input']>;
  minBet?: InputMaybe<Scalars['Float']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderExportsResponse = {
  __typename?: 'ProviderExportsResponse';
  _id?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  exportType?: Maybe<TableKeyEnum>;
  filename?: Maybe<Scalars['String']['output']>;
  finishedOn?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<ExportStatus>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ProviderIgnoredRequests = {
  __typename?: 'ProviderIgnoredRequests';
  betAmount?: Maybe<Scalars['String']['output']>;
  betId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  endDate: Scalars['DateTime']['output'];
  gameId: Scalars['Int']['output'];
  operation: Scalars['String']['output'];
  playerId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  roundId: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
};

export enum ProviderIntegrationType {
  Direct = 'DIRECT',
}

export type ProviderRgs = {
  __typename?: 'ProviderRgs';
  providerId: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  rgsId: Rgs;
};

export enum ProviderStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export type ProviderTransaction = {
  __typename?: 'ProviderTransaction';
  _id: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  balance: Scalars['Float']['output'];
  betId: Scalars['String']['output'];
  category: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['DateTime']['output'];
  gameId: Scalars['Float']['output'];
  language?: Maybe<Scalars['String']['output']>;
  multiplier?: Maybe<Scalars['Float']['output']>;
  operation: Scalars['String']['output'];
  playerId: Scalars['String']['output'];
  previousTransactionId?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  roundId: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  status?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  activePlayerMinesRound?: Maybe<MinesRoundConfigType>;
  activePlayerRubberDuckRound?: Maybe<RubberDuckRoundConfigType>;
  defaultCurrencyConfigs: Array<ProviderConfig>;
  exchangeRates: Array<ExchangeRate>;
  exportCurrencyConfigs: Scalars['String']['output'];
  exportLocalizations?: Maybe<Scalars['String']['output']>;
  exportStatus: ExportStatusResponse;
  freeBetCampaign?: Maybe<FreeBetsCampaign>;
  freeBetUsageLog?: Maybe<FreeBetsUsageLog>;
  freeBetsUsage?: Maybe<FreeBetsUsage>;
  localization?: Maybe<Localization>;
  localizations?: Maybe<LocalizationObjectType>;
  minesRound?: Maybe<MinesRoundConfigType>;
  minesRoundsByPlayer: Array<MinesRoundConfigType>;
  paginatedFreeBets: PaginatedFreeBets;
  paginatedFreeBetsCampaigns: PaginatedFreeBetsCampaigns;
  paginatedFreeBetsUsageLogs: PaginatedFreeBetsUsageLogs;
  paginatedMinesRounds: PaginatedMinesRounds;
  paginatedProviderIgnoredRequests: PaginatedProviderIgnoredRequests;
  paginatedProviderTransactions: PaginatedProviderTransactions;
  paginatedRubberDuckRounds: PaginatedRubberDuckRounds;
  permissions: Array<Scalars['String']['output']>;
  provider?: Maybe<Provider>;
  providerConfigs: Array<ProviderConfig>;
  providerExports: Array<ProviderExportsResponse>;
  providerPublicKey?: Maybe<Scalars['String']['output']>;
  providerTransaction?: Maybe<ProviderTransaction>;
  providers: Array<Provider>;
  providersFromAllRGS: Array<ProviderRgs>;
  raindropCampaigns: PaginatedRaindropCampaign;
  retryConfigs: Array<RetryConfig>;
  role: Role;
  roles: Array<Role>;
  rubberDuckRound?: Maybe<RubberDuckRoundConfigType>;
  rubberDuckRoundsByPlayer: Array<RubberDuckRoundConfigType>;
  session: BackOfficeSession;
  user: User;
  userProviders: Array<UserProvider>;
  users: Array<User>;
};

export type QueryActivePlayerMinesRoundArgs = {
  playerId: Scalars['String']['input'];
};

export type QueryActivePlayerRubberDuckRoundArgs = {
  playerId: Scalars['String']['input'];
};

export type QueryExchangeRatesArgs = {
  input: InputFilterExchangeRates;
};

export type QueryExportCurrencyConfigsArgs = {
  filter?: InputMaybe<ProviderConfigFilter>;
  providerId: Scalars['String']['input'];
};

export type QueryExportLocalizationsArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryExportStatusArgs = {
  exportId: Scalars['String']['input'];
};

export type QueryFreeBetCampaignArgs = {
  id: Scalars['String']['input'];
};

export type QueryFreeBetUsageLogArgs = {
  id: Scalars['String']['input'];
};

export type QueryFreeBetsUsageArgs = {
  id: Scalars['String']['input'];
};

export type QueryLocalizationArgs = {
  language: Scalars['String']['input'];
};

export type QueryLocalizationsArgs = {
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryMinesRoundArgs = {
  roundId: Scalars['String']['input'];
};

export type QueryMinesRoundsByPlayerArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  playerId: Scalars['String']['input'];
};

export type QueryPaginatedFreeBetsArgs = {
  filter?: InputMaybe<InputFilterFreeBetsUsage>;
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPaginatedFreeBetsCampaignsArgs = {
  filter?: InputMaybe<InputFilterFreeBetsCampagins>;
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryPaginatedFreeBetsUsageLogsArgs = {
  filter?: InputMaybe<InputFilterFreeBetUsageLogs>;
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
};

export type QueryPaginatedMinesRoundsArgs = {
  filter?: InputMaybe<InputFilterMinesRounds>;
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
};

export type QueryPaginatedProviderIgnoredRequestsArgs = {
  filter?: InputMaybe<InputFilterIgnoredRequests>;
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
};

export type QueryPaginatedProviderTransactionsArgs = {
  filter?: InputMaybe<InputFilterProviderTransaction>;
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
};

export type QueryPaginatedRubberDuckRoundsArgs = {
  filter?: InputMaybe<InputFilterRubberDuckRounds>;
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
};

export type QueryProviderArgs = {
  providerId: Scalars['String']['input'];
};

export type QueryProviderConfigsArgs = {
  filter?: InputMaybe<ProviderConfigFilter>;
  id: Scalars['String']['input'];
};

export type QueryProviderPublicKeyArgs = {
  providerId: Scalars['String']['input'];
};

export type QueryProviderTransactionArgs = {
  id: Scalars['String']['input'];
};

export type QueryProvidersArgs = {
  filters?: InputMaybe<InputProviderFilter>;
};

export type QueryRaindropCampaignsArgs = {
  filter?: InputMaybe<RaindropCampaignFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type QueryRoleArgs = {
  id: Scalars['String']['input'];
};

export type QueryRubberDuckRoundArgs = {
  roundId: Scalars['String']['input'];
};

export type QueryRubberDuckRoundsByPlayerArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  playerId: Scalars['String']['input'];
};

export type QueryUserArgs = {
  id: Scalars['String']['input'];
};

/** RGS identifiers */
export enum Rgs {
  Af = 'AF',
  As = 'AS',
  As1 = 'AS1',
  Eu = 'EU',
  Sa = 'SA',
}

export type RaindropCampaignFilterInput = {
  casinoId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<RaindropCampaignStatus>;
};

export enum RaindropCampaignStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Pending = 'PENDING',
}

export type RaindropCampaignType = {
  __typename?: 'RaindropCampaignType';
  _id?: Maybe<Scalars['String']['output']>;
  casinoId?: Maybe<Scalars['String']['output']>;
  claimDeadlineMinutes: Scalars['Float']['output'];
  claimLimitNumber: Scalars['Float']['output'];
  claimLimitPeriod?: Maybe<ClaimLimitPeriod>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  dayBudget?: Maybe<Scalars['Float']['output']>;
  distributionFrom: Scalars['Float']['output'];
  distributionTo: Scalars['Float']['output'];
  endDate: Scalars['DateTime']['output'];
  freebetValidityDate: Scalars['DateTime']['output'];
  freebetsPerRain: Scalars['Float']['output'];
  gameId: Scalars['Float']['output'];
  minMultiplier: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  playerMinBalance?: Maybe<Scalars['Float']['output']>;
  playerMinWager?: Maybe<Scalars['Float']['output']>;
  providerId: Scalars['String']['output'];
  rainsPerDay: Scalars['Float']['output'];
  startDate: Scalars['DateTime']['output'];
  status: RaindropCampaignStatus;
  totalBudget?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  wagerPeriod?: Maybe<Scalars['Float']['output']>;
};

export type RetryConfig = {
  __typename?: 'RetryConfig';
  _id?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  intervals: Array<Scalars['Float']['output']>;
  maxDuration: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Role = {
  __typename?: 'Role';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isEditable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
};

export type RubberDuckAutobetConfig = {
  __typename?: 'RubberDuckAutobetConfig';
  increaseOnLoss?: Maybe<Scalars['Float']['output']>;
  increaseOnWin?: Maybe<Scalars['Float']['output']>;
  numberOfBets?: Maybe<Scalars['Int']['output']>;
  stopOnLoss?: Maybe<Scalars['Float']['output']>;
  stopOnProfit?: Maybe<Scalars['Float']['output']>;
  targetLane?: Maybe<Scalars['Int']['output']>;
};

export type RubberDuckCrossedLane = {
  __typename?: 'RubberDuckCrossedLane';
  lane: Scalars['Int']['output'];
  multiplier: Scalars['Float']['output'];
};

export type RubberDuckRoundConfigType = {
  __typename?: 'RubberDuckRoundConfigType';
  _id?: Maybe<Scalars['ID']['output']>;
  autobetConfig?: Maybe<RubberDuckAutobetConfig>;
  autoplay: Scalars['Boolean']['output'];
  betAmount: Scalars['Float']['output'];
  clientHash: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  crossedLanes: Array<RubberDuckCrossedLane>;
  currency: Scalars['String']['output'];
  currentMultiplier: Scalars['Float']['output'];
  difficulty: Scalars['String']['output'];
  failLane: Scalars['Int']['output'];
  gameData?: Maybe<Scalars['JSON']['output']>;
  gameId: Scalars['Int']['output'];
  laneCount: Scalars['Int']['output'];
  maxWin?: Maybe<Scalars['Float']['output']>;
  playerId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  reachedLane?: Maybe<Scalars['Int']['output']>;
  roundHash: Scalars['String']['output'];
  roundId: Scalars['String']['output'];
  serverHash: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalWinAmount: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Session = {
  __typename?: 'Session';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isSuper?: Maybe<Scalars['Boolean']['output']>;
  permissions: Array<Scalars['String']['output']>;
  providerIds?: Maybe<Array<Scalars['String']['output']>>;
  rgsIds?: Maybe<Array<Rgs>>;
};

export enum TableKeyEnum {
  FailedSendCreditTasks = 'FAILED_SEND_CREDIT_TASKS',
  FailedSendCreditTransactions = 'FAILED_SEND_CREDIT_TRANSACTIONS',
  ProviderIgnoredRequests = 'PROVIDER_IGNORED_REQUESTS',
  ProviderTransactions = 'PROVIDER_TRANSACTIONS',
  ScheduledSendCreditTasks = 'SCHEDULED_SEND_CREDIT_TASKS',
}

export type TestCheck = {
  __typename?: 'TestCheck';
  endpoint: Scalars['String']['output'];
  errors?: Maybe<Array<ErrorsType>>;
  testCase?: Maybe<Scalars['String']['output']>;
};

export type TestProviderResponseObjectType = {
  __typename?: 'TestProviderResponseObjectType';
  data?: Maybe<Array<TestCheck>>;
  errorsCount?: Maybe<Scalars['Float']['output']>;
  message: Scalars['String']['output'];
};

export type TestProvidersInput = {
  /** transactionAmountNominal */
  amount: Scalars['Int']['input'];
  /** Currency Type: EUR | USD | GEL etc. */
  currency: Scalars['String']['input'];
  /** client url for example: http://localhost:3000?token=lyNpWc3xE1UDzPs25vNB%2BHYLODWpUTNEksSrCTK5Cgn2ZrE3u06SBEnBeaPEeaRYojsOMtbCbewokQSezGN5MEjSlkeJuMPvoBg1vMRqBUGUbkfJ7cd5m%2BCxcYEhgx8Ebjl8RbNIUt0aR%2FRZMaU988zshOGNd7WmCwNRJ8I0ma6ni4Kjhv3j8Q3%2FX%2Fvge1rsVzkSQ7KXaBbHMWZQ6Cxql8eQEueAAnjItfa0gvGgO3b4C0LYrgYGTq7L4jJ5B8an7WT6Pae8jUg%2FwlU8is4G0lXnanzreBemPWOWF0ZzcMxf6H%2Baw%2FNKOv6YTBseRYw7%2B83jsOBng0fQllSSPGTGLg%3D%3D&providerId=66ffba1337e994c3009ebf40&currency=GEL&language=en */
  url: Scalars['String']['input'];
};

export type UpdateProviderArgs = {
  apiUrl?: InputMaybe<Scalars['String']['input']>;
  configId?: InputMaybe<Scalars['String']['input']>;
  creditOnDisconnect?: InputMaybe<Scalars['Boolean']['input']>;
  filterExternalProviderBets?: InputMaybe<Scalars['Boolean']['input']>;
  games?: InputMaybe<Array<Scalars['Int']['input']>>;
  integrationType?: InputMaybe<ProviderIntegrationType>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  refundOnCreditFail?: InputMaybe<Scalars['Boolean']['input']>;
  retryConfigId?: InputMaybe<Scalars['String']['input']>;
  retryScheduledSendCredit?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ProviderStatus>;
  syncRoundEnd?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateProviderConfigArgs = {
  betSuggestions?: InputMaybe<Array<Scalars['Float']['input']>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  defaultAutoCashout?: InputMaybe<Scalars['Float']['input']>;
  defaultBet?: InputMaybe<Scalars['Float']['input']>;
  isRoundable?: InputMaybe<Scalars['Boolean']['input']>;
  maxAutoCashout?: InputMaybe<Scalars['Float']['input']>;
  maxBet?: InputMaybe<Scalars['Float']['input']>;
  maxWin?: InputMaybe<Scalars['Float']['input']>;
  minAutoCashout?: InputMaybe<Scalars['Float']['input']>;
  minBet?: InputMaybe<Scalars['Float']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  games: Array<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  password: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerRgs?: Maybe<Array<UserProviderRgs>>;
  roleIds: Array<Scalars['String']['output']>;
};

export type UserProvider = {
  __typename?: 'UserProvider';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type UserProviderRgs = {
  __typename?: 'UserProviderRgs';
  providerIds: Array<Scalars['String']['output']>;
  rgsId: Rgs;
};

export type PaginatedFreeBetsCampaignsQueryVariables = Exact<{
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
  search: Scalars['String']['input'];
  filter: InputFilterFreeBetsCampagins;
}>;

export type PaginatedFreeBetsCampaignsQuery = {
  __typename?: 'Query';
  paginatedFreeBetsCampaigns: {
    __typename?: 'PaginatedFreeBetsCampaigns';
    total: number;
    page: number;
    limit: number;
    skip?: number | null;
    docs: Array<{
      __typename?: 'FreeBetsCampaign';
      _id: string;
      description: string;
      providerId: string;
      startDate: any;
      endDate: any;
      campaignUniqueId: string;
      status: string;
      createdAt: any;
    }>;
  };
};

export type PaginatedFreeBetsQueryVariables = Exact<{
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
  filter: InputFilterFreeBetsUsage;
  search: Scalars['String']['input'];
}>;

export type PaginatedFreeBetsQuery = {
  __typename?: 'Query';
  paginatedFreeBets: {
    __typename?: 'PaginatedFreeBets';
    total: number;
    page: number;
    limit: number;
    skip?: number | null;
    docs: Array<{
      __typename?: 'FreeBetsUsage';
      _id: string;
      campaignId: string;
      requestId: string;
      providerId: string;
      playerId: string;
      usage: number;
      totalWin: number;
      validityDate: any;
      description: string;
      count: number;
      minMultiplier: number;
      betNominal: number;
      status: string;
      createdAt: any;
    }>;
  };
};

export type PaginatedFreeBetsUsageLogsQueryVariables = Exact<{
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
  filter: InputFilterFreeBetUsageLogs;
}>;

export type PaginatedFreeBetsUsageLogsQuery = {
  __typename?: 'Query';
  paginatedFreeBetsUsageLogs: {
    __typename?: 'PaginatedFreeBetsUsageLogs';
    total: number;
    page: number;
    limit: number;
    skip?: number | null;
    docs: Array<{
      __typename?: 'FreeBetsUsageLog';
      _id: string;
      campaignId: string;
      usageId: string;
      providerId: string;
      roundId: string;
      gameId: number;
      win: number;
      createdAt: any;
      updatedAt: any;
    }>;
  };
};

export type GetLocalizationQueryVariables = Exact<{
  language: Scalars['String']['input'];
}>;

export type GetLocalizationQuery = {
  __typename?: 'Query';
  localization?: {
    __typename?: 'Localization';
    _id: string;
    language: string;
    translations: string;
    gameId: number;
  } | null;
};

export type UpdateLocalizationMutationVariables = Exact<{
  input: InputUpdateLocalization;
}>;

export type UpdateLocalizationMutation = { __typename?: 'Mutation'; updateLocalization: boolean };

export type LocalizationsQueryVariables = Exact<{
  languages?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type LocalizationsQuery = {
  __typename?: 'Query';
  localizations?: {
    __typename?: 'LocalizationObjectType';
    translations: string;
    languages?: Array<string> | null;
  } | null;
};

export type ExportLocalizationsQueryVariables = Exact<{
  languages?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type ExportLocalizationsQuery = {
  __typename?: 'Query';
  exportLocalizations?: string | null;
};

export type AddLocalizationKeyMutationVariables = Exact<{
  input: InputUpdateLocalization;
}>;

export type AddLocalizationKeyMutation = { __typename?: 'Mutation'; addLocalizationKey: boolean };

export type AddNewLanguageMutationVariables = Exact<{
  newLanguage: Scalars['String']['input'];
}>;

export type AddNewLanguageMutation = { __typename?: 'Mutation'; addNewLanguage?: boolean | null };

export type GetProvidersQueryVariables = Exact<{
  filters?: InputMaybe<InputProviderFilter>;
}>;

export type GetProvidersQuery = {
  __typename?: 'Query';
  providers: Array<{
    __typename?: 'Provider';
    id: string;
    createdAt?: any | null;
    updatedAt?: any | null;
    name: string;
    apiUrl: string;
    syncRoundEnd?: boolean | null;
    status?: ProviderStatus | null;
    retryScheduledSendCredit?: boolean | null;
    refundOnCreditFail?: boolean | null;
    filterExternalProviderBets?: boolean | null;
    isInternal?: boolean | null;
    rgsId?: Rgs | null;
    configId?: string | null;
    games: Array<number>;
    creditOnDisconnect?: boolean | null;
    integrationType?: ProviderIntegrationType | null;
  }>;
};

export type CreateProviderMutationVariables = Exact<{
  input: CreateProviderArgs;
}>;

export type CreateProviderMutation = {
  __typename?: 'Mutation';
  createProvider: { __typename?: 'Provider'; id: string; name: string };
};

export type GetProviderQueryVariables = Exact<{
  providerId: Scalars['String']['input'];
}>;

export type GetProviderQuery = {
  __typename?: 'Query';
  provider?: {
    __typename?: 'Provider';
    id: string;
    createdAt?: any | null;
    updatedAt?: any | null;
    name: string;
    apiUrl: string;
    syncRoundEnd?: boolean | null;
    status?: ProviderStatus | null;
    retryScheduledSendCredit?: boolean | null;
    retryConfigId?: string | null;
    refundOnCreditFail?: boolean | null;
    filterExternalProviderBets?: boolean | null;
    isInternal?: boolean | null;
    rgsId?: Rgs | null;
    configId?: string | null;
    games: Array<number>;
    creditOnDisconnect?: boolean | null;
    integrationType?: ProviderIntegrationType | null;
  } | null;
};

export type UpdateProviderMutationVariables = Exact<{
  providerId: Scalars['String']['input'];
  input: UpdateProviderArgs;
}>;

export type UpdateProviderMutation = { __typename?: 'Mutation'; updateProvider: number };

export type GetProviderConfigsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  filter?: InputMaybe<ProviderConfigFilter>;
}>;

export type GetProviderConfigsQuery = {
  __typename?: 'Query';
  providerConfigs: Array<{
    __typename?: 'ProviderConfig';
    id: string;
    providerId?: string | null;
    createdAt: any;
    updatedAt: any;
    maxWin: number;
    minBet: number;
    maxBet: number;
    betSuggestions: Array<number>;
    minAutoCashout?: number | null;
    defaultAutoCashout?: number | null;
    maxAutoCashout?: number | null;
    defaultBet: number;
    currency: string;
    isRoundable: boolean;
  }>;
};

export type GetProviderPublicKeyQueryVariables = Exact<{
  providerId: Scalars['String']['input'];
}>;

export type GetProviderPublicKeyQuery = { __typename?: 'Query'; providerPublicKey?: string | null };

export type CreateProviderConfigMutationVariables = Exact<{
  input: CreateProviderConfigArgs;
}>;

export type CreateProviderConfigMutation = {
  __typename?: 'Mutation';
  createProviderConfig: { __typename?: 'ProviderConfig'; id: string };
};

export type UpdateProviderConfigMutationVariables = Exact<{
  configId: Scalars['String']['input'];
  input: UpdateProviderConfigArgs;
}>;

export type UpdateProviderConfigMutation = {
  __typename?: 'Mutation';
  updateProviderConfig: number;
};

export type DeleteProviderConfigMutationVariables = Exact<{
  configId: Scalars['String']['input'];
}>;

export type DeleteProviderConfigMutation = {
  __typename?: 'Mutation';
  deleteProviderConfig: number;
};

export type ExportCurrencyConfigsQueryVariables = Exact<{
  providerId: Scalars['String']['input'];
  filter?: InputMaybe<ProviderConfigFilter>;
}>;

export type ExportCurrencyConfigsQuery = { __typename?: 'Query'; exportCurrencyConfigs: string };

export type GetProvidersFromAllRgsQueryVariables = Exact<{ [key: string]: never }>;

export type GetProvidersFromAllRgsQuery = {
  __typename?: 'Query';
  providersFromAllRGS: Array<{
    __typename?: 'ProviderRgs';
    rgsId: Rgs;
    providerId: string;
    providerName: string;
  }>;
};

export type DeleteProviderConfigIdMutationVariables = Exact<{
  providerId: Scalars['String']['input'];
}>;

export type DeleteProviderConfigIdMutation = {
  __typename?: 'Mutation';
  deleteProviderConfigId: number;
};

export type GetRetryConfigsQueryVariables = Exact<{ [key: string]: never }>;

export type GetRetryConfigsQuery = {
  __typename?: 'Query';
  retryConfigs: Array<{ __typename?: 'RetryConfig'; _id?: string | null; name: string }>;
};

export type CreateRaindropCampaignMutationVariables = Exact<{
  input: CreateRaindropCampaignInput;
}>;

export type CreateRaindropCampaignMutation = {
  __typename?: 'Mutation';
  createRaindropCampaign: {
    __typename?: 'CreateRaindropCampaignType';
    id?: string | null;
    status?: string | null;
    message?: string | null;
  };
};

export type PaginatedMinesRoundsQueryVariables = Exact<{
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
  filter?: InputMaybe<InputFilterMinesRounds>;
}>;

export type PaginatedMinesRoundsQuery = {
  __typename?: 'Query';
  paginatedMinesRounds: {
    __typename?: 'PaginatedMinesRounds';
    total: number;
    page: number;
    limit: number;
    skip?: number | null;
    docs: Array<{
      __typename?: 'MinesRoundConfigType';
      _id?: string | null;
      roundId: string;
      playerId: string;
      createdAt?: any | null;
      roundHash: string;
      clientHash: string;
      serverHash: string;
    }>;
  };
};

export type MinesRoundQueryVariables = Exact<{
  roundId: Scalars['String']['input'];
}>;

export type MinesRoundQuery = {
  __typename?: 'Query';
  minesRound?: {
    __typename?: 'MinesRoundConfigType';
    _id?: string | null;
    betAmount: number;
    gridSize: number;
    minesCount: number;
    autoplay: boolean;
    autobetConfig?: {
      __typename?: 'MinesAutobetConfig';
      numberOfBets?: number | null;
      payoutOnWin?: number | null;
      increaseOnWin?: number | null;
      increaseOnLoss?: number | null;
      stopOnProfit?: number | null;
      stopOnLoss?: number | null;
    } | null;
    revealedTiles: Array<{
      __typename?: 'MinesRevealedTile';
      tileNumber: number;
      multiplier: number;
      mine: boolean;
    }>;
  } | null;
};

export type PaginatedRubberDuckRoundsQueryVariables = Exact<{
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
  filter?: InputMaybe<InputFilterRubberDuckRounds>;
}>;

export type PaginatedRubberDuckRoundsQuery = {
  __typename?: 'Query';
  paginatedRubberDuckRounds: {
    __typename?: 'PaginatedRubberDuckRounds';
    total: number;
    page: number;
    limit: number;
    skip?: number | null;
    docs: Array<{
      __typename?: 'RubberDuckRoundConfigType';
      _id?: string | null;
      roundId: string;
      playerId: string;
      difficulty: string;
      betAmount: number;
      currency: string;
      laneCount: number;
      reachedLane?: number | null;
      currentMultiplier: number;
      totalWinAmount: number;
      status: string;
      createdAt?: any | null;
    }>;
  };
};

export type RubberDuckRoundQueryVariables = Exact<{
  roundId: Scalars['String']['input'];
}>;

export type RubberDuckRoundQuery = {
  __typename?: 'Query';
  rubberDuckRound?: {
    __typename?: 'RubberDuckRoundConfigType';
    _id?: string | null;
    roundId: string;
    playerId: string;
    providerId: string;
    gameId: number;
    betAmount: number;
    currency: string;
    difficulty: string;
    laneCount: number;
    failLane: number;
    reachedLane?: number | null;
    currentMultiplier: number;
    totalWinAmount: number;
    maxWin?: number | null;
    status: string;
    autoplay: boolean;
    clientHash: string;
    serverHash: string;
    roundHash: string;
    createdAt?: any | null;
    completedAt?: any | null;
    crossedLanes: Array<{ __typename?: 'RubberDuckCrossedLane'; lane: number; multiplier: number }>;
    autobetConfig?: {
      __typename?: 'RubberDuckAutobetConfig';
      numberOfBets?: number | null;
      targetLane?: number | null;
      increaseOnWin?: number | null;
      increaseOnLoss?: number | null;
      stopOnProfit?: number | null;
      stopOnLoss?: number | null;
    } | null;
  } | null;
};

export type RubberDuckRoundsByPlayerQueryVariables = Exact<{
  playerId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;

export type RubberDuckRoundsByPlayerQuery = {
  __typename?: 'Query';
  rubberDuckRoundsByPlayer: Array<{
    __typename?: 'RubberDuckRoundConfigType';
    _id?: string | null;
    roundId: string;
    difficulty: string;
    betAmount: number;
    currency: string;
    laneCount: number;
    reachedLane?: number | null;
    currentMultiplier: number;
    totalWinAmount: number;
    status: string;
    createdAt?: any | null;
  }>;
};

export type ActivePlayerRubberDuckRoundQueryVariables = Exact<{
  playerId: Scalars['String']['input'];
}>;

export type ActivePlayerRubberDuckRoundQuery = {
  __typename?: 'Query';
  activePlayerRubberDuckRound?: {
    __typename?: 'RubberDuckRoundConfigType';
    _id?: string | null;
    roundId: string;
    playerId: string;
    difficulty: string;
    betAmount: number;
    currency: string;
    laneCount: number;
    reachedLane?: number | null;
    currentMultiplier: number;
    status: string;
    createdAt?: any | null;
  } | null;
};

export type TestProviderMutationVariables = Exact<{
  testProviderInput: TestProvidersInput;
}>;

export type TestProviderMutation = {
  __typename?: 'Mutation';
  testProvider: {
    __typename?: 'TestProviderResponseObjectType';
    errorsCount?: number | null;
    message: string;
    data?: Array<{
      __typename?: 'TestCheck';
      endpoint: string;
      testCase?: string | null;
      errors?: Array<{ __typename?: 'ErrorsType'; err: string }> | null;
    }> | null;
  };
};

export type PaginatedProviderTransactionsQueryVariables = Exact<{
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
  filter: InputFilterProviderTransaction;
}>;

export type PaginatedProviderTransactionsQuery = {
  __typename?: 'Query';
  paginatedProviderTransactions: {
    __typename?: 'PaginatedProviderTransactions';
    total: number;
    page: number;
    limit: number;
    skip?: number | null;
    docs: Array<{
      __typename?: 'ProviderTransaction';
      _id: string;
      createdAt?: any | null;
      status?: string | null;
      category: string;
      language?: string | null;
      currency?: string | null;
      roundId: string;
      transactionId?: string | null;
      operation: string;
      reason?: string | null;
      providerId: string;
      playerId: string;
      amount: number;
      multiplier?: number | null;
      balance: number;
      gameId: number;
    }>;
  };
};

export type PaginatedProviderIgnoredRequestsQueryVariables = Exact<{
  limit: Scalars['Float']['input'];
  page: Scalars['Float']['input'];
  filter: InputFilterIgnoredRequests;
}>;

export type PaginatedProviderIgnoredRequestsQuery = {
  __typename?: 'Query';
  paginatedProviderIgnoredRequests: {
    __typename?: 'PaginatedProviderIgnoredRequests';
    total: number;
    page: number;
    limit: number;
    skip?: number | null;
    docs: Array<{
      __typename?: 'ProviderIgnoredRequests';
      startDate: any;
      endDate: any;
      betId: string;
      betAmount?: string | null;
    }>;
  };
};

export type ProviderExportsQueryVariables = Exact<{ [key: string]: never }>;

export type ProviderExportsQuery = {
  __typename?: 'Query';
  providerExports: Array<{
    __typename?: 'ProviderExportsResponse';
    _id?: string | null;
    exportType?: TableKeyEnum | null;
    status?: ExportStatus | null;
    createdAt?: any | null;
    finishedOn?: any | null;
    filename?: string | null;
    url?: string | null;
  }>;
};

export type ExportTransactionsToExcelMutationVariables = Exact<{
  input: ExportExcelInput;
}>;

export type ExportTransactionsToExcelMutation = {
  __typename?: 'Mutation';
  exportTransactionsToExcel: {
    __typename?: 'CreateExportResponse';
    status: ExportStatus;
    exportId: string;
  };
};

export type GetUsersQueryVariables = Exact<{ [key: string]: never }>;

export type GetUsersQuery = {
  __typename?: 'Query';
  users: Array<{
    __typename?: 'User';
    id: string;
    email: string;
    providerId: string;
    roleIds: Array<string>;
    games: Array<number>;
    providerRgs?: Array<{
      __typename?: 'UserProviderRgs';
      rgsId: Rgs;
      providerIds: Array<string>;
    }> | null;
  }>;
};

export type GetUserQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetUserQuery = {
  __typename?: 'Query';
  user: {
    __typename?: 'User';
    id: string;
    email: string;
    providerId: string;
    roleIds: Array<string>;
    games: Array<number>;
    providerRgs?: Array<{
      __typename?: 'UserProviderRgs';
      rgsId: Rgs;
      providerIds: Array<string>;
    }> | null;
  };
};

export type GetRolesQueryVariables = Exact<{ [key: string]: never }>;

export type GetRolesQuery = {
  __typename?: 'Query';
  roles: Array<{
    __typename?: 'Role';
    id: string;
    name: string;
    description: string;
    permissions: Array<string>;
    isEditable: boolean;
  }>;
};

export type GetRoleQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetRoleQuery = {
  __typename?: 'Query';
  role: {
    __typename?: 'Role';
    id: string;
    name: string;
    description: string;
    permissions: Array<string>;
  };
};

export type GetPermissionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetPermissionsQuery = { __typename?: 'Query'; permissions: Array<string> };

export type CreateRoleMutationVariables = Exact<{
  input: InputCreateRole;
}>;

export type CreateRoleMutation = {
  __typename?: 'Mutation';
  createRole: { __typename?: 'Role'; id: string };
};

export type CreateUserMutationVariables = Exact<{
  input: InputCreateUser;
}>;

export type CreateUserMutation = {
  __typename?: 'Mutation';
  createUser: { __typename?: 'User'; id: string };
};

export type DeleteRoleMutationVariables = Exact<{
  input: InputDeleteRole;
}>;

export type DeleteRoleMutation = { __typename?: 'Mutation'; deleteRole: number };

export type GetSessionQueryVariables = Exact<{ [key: string]: never }>;

export type GetSessionQuery = {
  __typename?: 'Query';
  session: {
    __typename?: 'BackOfficeSession';
    provider?: { __typename?: 'Provider'; id: string; name: string; games: Array<number> } | null;
    session: {
      __typename?: 'Session';
      id: string;
      email?: string | null;
      providerIds?: Array<string> | null;
      permissions: Array<string>;
      isSuper?: boolean | null;
      rgsIds?: Array<Rgs> | null;
    };
  };
};

export type SignInMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;

export type SignInMutation = {
  __typename?: 'Mutation';
  signIn: { __typename?: 'AuthPayload'; accessToken: string; refreshToken: string };
};

export type RefreshTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type RefreshTokenMutation = {
  __typename?: 'Mutation';
  refreshToken: { __typename?: 'AuthPayload'; accessToken: string; refreshToken: string };
};

export type CreateAviatorPermissionMutationVariables = Exact<{
  permission: Scalars['String']['input'];
}>;

export type CreateAviatorPermissionMutation = { __typename?: 'Mutation'; addPermission: number };

export type DeleteSelectedRolePermissionMutationVariables = Exact<{
  input: InputRemoveRolePermission;
}>;

export type DeleteSelectedRolePermissionMutation = {
  __typename?: 'Mutation';
  removeRolePermission: number;
};

export type AssignRolePermissionsMutationVariables = Exact<{
  input: InputAssignRolePermissions;
}>;

export type AssignRolePermissionsMutation = {
  __typename?: 'Mutation';
  assignRolePermissions: boolean;
};

export type LogoutMutationVariables = Exact<{ [key: string]: never }>;

export type LogoutMutation = { __typename?: 'Mutation'; logout: boolean };

export const PaginatedFreeBetsCampaignsDocument = gql`
  query paginatedFreeBetsCampaigns(
    $limit: Float!
    $page: Float!
    $search: String!
    $filter: InputFilterFreeBetsCampagins!
  ) {
    paginatedFreeBetsCampaigns(limit: $limit, page: $page, search: $search, filter: $filter) {
      total
      page
      limit
      skip
      docs {
        _id
        description
        providerId
        startDate
        endDate
        campaignUniqueId
        status
        createdAt
      }
    }
  }
`;

/**
 * __usePaginatedFreeBetsCampaignsQuery__
 *
 * To run a query within a React component, call `usePaginatedFreeBetsCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedFreeBetsCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedFreeBetsCampaignsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePaginatedFreeBetsCampaignsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PaginatedFreeBetsCampaignsQuery,
    PaginatedFreeBetsCampaignsQueryVariables
  > &
    ({ variables: PaginatedFreeBetsCampaignsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PaginatedFreeBetsCampaignsQuery, PaginatedFreeBetsCampaignsQueryVariables>(
    PaginatedFreeBetsCampaignsDocument,
    options
  );
}
export function usePaginatedFreeBetsCampaignsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaginatedFreeBetsCampaignsQuery,
    PaginatedFreeBetsCampaignsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PaginatedFreeBetsCampaignsQuery,
    PaginatedFreeBetsCampaignsQueryVariables
  >(PaginatedFreeBetsCampaignsDocument, options);
}
export function usePaginatedFreeBetsCampaignsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PaginatedFreeBetsCampaignsQuery,
    PaginatedFreeBetsCampaignsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PaginatedFreeBetsCampaignsQuery,
    PaginatedFreeBetsCampaignsQueryVariables
  >(PaginatedFreeBetsCampaignsDocument, options);
}
export type PaginatedFreeBetsCampaignsQueryHookResult = ReturnType<
  typeof usePaginatedFreeBetsCampaignsQuery
>;
export type PaginatedFreeBetsCampaignsLazyQueryHookResult = ReturnType<
  typeof usePaginatedFreeBetsCampaignsLazyQuery
>;
export type PaginatedFreeBetsCampaignsSuspenseQueryHookResult = ReturnType<
  typeof usePaginatedFreeBetsCampaignsSuspenseQuery
>;
export type PaginatedFreeBetsCampaignsQueryResult = Apollo.QueryResult<
  PaginatedFreeBetsCampaignsQuery,
  PaginatedFreeBetsCampaignsQueryVariables
>;
export const PaginatedFreeBetsDocument = gql`
  query paginatedFreeBets(
    $limit: Float!
    $page: Float!
    $filter: InputFilterFreeBetsUsage!
    $search: String!
  ) {
    paginatedFreeBets(limit: $limit, page: $page, filter: $filter, search: $search) {
      total
      page
      limit
      skip
      docs {
        _id
        campaignId
        requestId
        providerId
        playerId
        usage
        totalWin
        validityDate
        description
        count
        minMultiplier
        betNominal
        status
        createdAt
      }
    }
  }
`;

/**
 * __usePaginatedFreeBetsQuery__
 *
 * To run a query within a React component, call `usePaginatedFreeBetsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedFreeBetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedFreeBetsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      search: // value for 'search'
 *   },
 * });
 */
export function usePaginatedFreeBetsQuery(
  baseOptions: Apollo.QueryHookOptions<PaginatedFreeBetsQuery, PaginatedFreeBetsQueryVariables> &
    ({ variables: PaginatedFreeBetsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PaginatedFreeBetsQuery, PaginatedFreeBetsQueryVariables>(
    PaginatedFreeBetsDocument,
    options
  );
}
export function usePaginatedFreeBetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PaginatedFreeBetsQuery, PaginatedFreeBetsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PaginatedFreeBetsQuery, PaginatedFreeBetsQueryVariables>(
    PaginatedFreeBetsDocument,
    options
  );
}
export function usePaginatedFreeBetsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PaginatedFreeBetsQuery,
    PaginatedFreeBetsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PaginatedFreeBetsQuery, PaginatedFreeBetsQueryVariables>(
    PaginatedFreeBetsDocument,
    options
  );
}
export type PaginatedFreeBetsQueryHookResult = ReturnType<typeof usePaginatedFreeBetsQuery>;
export type PaginatedFreeBetsLazyQueryHookResult = ReturnType<typeof usePaginatedFreeBetsLazyQuery>;
export type PaginatedFreeBetsSuspenseQueryHookResult = ReturnType<
  typeof usePaginatedFreeBetsSuspenseQuery
>;
export type PaginatedFreeBetsQueryResult = Apollo.QueryResult<
  PaginatedFreeBetsQuery,
  PaginatedFreeBetsQueryVariables
>;
export const PaginatedFreeBetsUsageLogsDocument = gql`
  query paginatedFreeBetsUsageLogs(
    $limit: Float!
    $page: Float!
    $filter: InputFilterFreeBetUsageLogs!
  ) {
    paginatedFreeBetsUsageLogs(limit: $limit, page: $page, filter: $filter) {
      total
      page
      limit
      skip
      docs {
        _id
        campaignId
        usageId
        providerId
        roundId
        gameId
        win
        createdAt
        updatedAt
      }
    }
  }
`;

/**
 * __usePaginatedFreeBetsUsageLogsQuery__
 *
 * To run a query within a React component, call `usePaginatedFreeBetsUsageLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedFreeBetsUsageLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedFreeBetsUsageLogsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePaginatedFreeBetsUsageLogsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PaginatedFreeBetsUsageLogsQuery,
    PaginatedFreeBetsUsageLogsQueryVariables
  > &
    ({ variables: PaginatedFreeBetsUsageLogsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PaginatedFreeBetsUsageLogsQuery, PaginatedFreeBetsUsageLogsQueryVariables>(
    PaginatedFreeBetsUsageLogsDocument,
    options
  );
}
export function usePaginatedFreeBetsUsageLogsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaginatedFreeBetsUsageLogsQuery,
    PaginatedFreeBetsUsageLogsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PaginatedFreeBetsUsageLogsQuery,
    PaginatedFreeBetsUsageLogsQueryVariables
  >(PaginatedFreeBetsUsageLogsDocument, options);
}
export function usePaginatedFreeBetsUsageLogsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PaginatedFreeBetsUsageLogsQuery,
    PaginatedFreeBetsUsageLogsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PaginatedFreeBetsUsageLogsQuery,
    PaginatedFreeBetsUsageLogsQueryVariables
  >(PaginatedFreeBetsUsageLogsDocument, options);
}
export type PaginatedFreeBetsUsageLogsQueryHookResult = ReturnType<
  typeof usePaginatedFreeBetsUsageLogsQuery
>;
export type PaginatedFreeBetsUsageLogsLazyQueryHookResult = ReturnType<
  typeof usePaginatedFreeBetsUsageLogsLazyQuery
>;
export type PaginatedFreeBetsUsageLogsSuspenseQueryHookResult = ReturnType<
  typeof usePaginatedFreeBetsUsageLogsSuspenseQuery
>;
export type PaginatedFreeBetsUsageLogsQueryResult = Apollo.QueryResult<
  PaginatedFreeBetsUsageLogsQuery,
  PaginatedFreeBetsUsageLogsQueryVariables
>;
export const GetLocalizationDocument = gql`
  query getLocalization($language: String!) {
    localization(language: $language) {
      _id
      language
      translations
      gameId
    }
  }
`;

/**
 * __useGetLocalizationQuery__
 *
 * To run a query within a React component, call `useGetLocalizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalizationQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGetLocalizationQuery(
  baseOptions: Apollo.QueryHookOptions<GetLocalizationQuery, GetLocalizationQueryVariables> &
    ({ variables: GetLocalizationQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLocalizationQuery, GetLocalizationQueryVariables>(
    GetLocalizationDocument,
    options
  );
}
export function useGetLocalizationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLocalizationQuery, GetLocalizationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLocalizationQuery, GetLocalizationQueryVariables>(
    GetLocalizationDocument,
    options
  );
}
export function useGetLocalizationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocalizationQuery, GetLocalizationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLocalizationQuery, GetLocalizationQueryVariables>(
    GetLocalizationDocument,
    options
  );
}
export type GetLocalizationQueryHookResult = ReturnType<typeof useGetLocalizationQuery>;
export type GetLocalizationLazyQueryHookResult = ReturnType<typeof useGetLocalizationLazyQuery>;
export type GetLocalizationSuspenseQueryHookResult = ReturnType<
  typeof useGetLocalizationSuspenseQuery
>;
export type GetLocalizationQueryResult = Apollo.QueryResult<
  GetLocalizationQuery,
  GetLocalizationQueryVariables
>;
export const UpdateLocalizationDocument = gql`
  mutation updateLocalization($input: InputUpdateLocalization!) {
    updateLocalization(input: $input)
  }
`;
export type UpdateLocalizationMutationFn = Apollo.MutationFunction<
  UpdateLocalizationMutation,
  UpdateLocalizationMutationVariables
>;

/**
 * __useUpdateLocalizationMutation__
 *
 * To run a mutation, you first call `useUpdateLocalizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocalizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocalizationMutation, { data, loading, error }] = useUpdateLocalizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLocalizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateLocalizationMutation,
    UpdateLocalizationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateLocalizationMutation, UpdateLocalizationMutationVariables>(
    UpdateLocalizationDocument,
    options
  );
}
export type UpdateLocalizationMutationHookResult = ReturnType<typeof useUpdateLocalizationMutation>;
export type UpdateLocalizationMutationResult = Apollo.MutationResult<UpdateLocalizationMutation>;
export type UpdateLocalizationMutationOptions = Apollo.BaseMutationOptions<
  UpdateLocalizationMutation,
  UpdateLocalizationMutationVariables
>;
export const LocalizationsDocument = gql`
  query localizations($languages: [String!]) {
    localizations(languages: $languages) {
      translations
      languages
    }
  }
`;

/**
 * __useLocalizationsQuery__
 *
 * To run a query within a React component, call `useLocalizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocalizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocalizationsQuery({
 *   variables: {
 *      languages: // value for 'languages'
 *   },
 * });
 */
export function useLocalizationsQuery(
  baseOptions?: Apollo.QueryHookOptions<LocalizationsQuery, LocalizationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LocalizationsQuery, LocalizationsQueryVariables>(
    LocalizationsDocument,
    options
  );
}
export function useLocalizationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LocalizationsQuery, LocalizationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LocalizationsQuery, LocalizationsQueryVariables>(
    LocalizationsDocument,
    options
  );
}
export function useLocalizationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<LocalizationsQuery, LocalizationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<LocalizationsQuery, LocalizationsQueryVariables>(
    LocalizationsDocument,
    options
  );
}
export type LocalizationsQueryHookResult = ReturnType<typeof useLocalizationsQuery>;
export type LocalizationsLazyQueryHookResult = ReturnType<typeof useLocalizationsLazyQuery>;
export type LocalizationsSuspenseQueryHookResult = ReturnType<typeof useLocalizationsSuspenseQuery>;
export type LocalizationsQueryResult = Apollo.QueryResult<
  LocalizationsQuery,
  LocalizationsQueryVariables
>;
export const ExportLocalizationsDocument = gql`
  query exportLocalizations($languages: [String!]) {
    exportLocalizations(languages: $languages)
  }
`;

/**
 * __useExportLocalizationsQuery__
 *
 * To run a query within a React component, call `useExportLocalizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportLocalizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportLocalizationsQuery({
 *   variables: {
 *      languages: // value for 'languages'
 *   },
 * });
 */
export function useExportLocalizationsQuery(
  baseOptions?: Apollo.QueryHookOptions<ExportLocalizationsQuery, ExportLocalizationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExportLocalizationsQuery, ExportLocalizationsQueryVariables>(
    ExportLocalizationsDocument,
    options
  );
}
export function useExportLocalizationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExportLocalizationsQuery,
    ExportLocalizationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExportLocalizationsQuery, ExportLocalizationsQueryVariables>(
    ExportLocalizationsDocument,
    options
  );
}
export function useExportLocalizationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExportLocalizationsQuery,
    ExportLocalizationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ExportLocalizationsQuery, ExportLocalizationsQueryVariables>(
    ExportLocalizationsDocument,
    options
  );
}
export type ExportLocalizationsQueryHookResult = ReturnType<typeof useExportLocalizationsQuery>;
export type ExportLocalizationsLazyQueryHookResult = ReturnType<
  typeof useExportLocalizationsLazyQuery
>;
export type ExportLocalizationsSuspenseQueryHookResult = ReturnType<
  typeof useExportLocalizationsSuspenseQuery
>;
export type ExportLocalizationsQueryResult = Apollo.QueryResult<
  ExportLocalizationsQuery,
  ExportLocalizationsQueryVariables
>;
export const AddLocalizationKeyDocument = gql`
  mutation addLocalizationKey($input: InputUpdateLocalization!) {
    addLocalizationKey(input: $input)
  }
`;
export type AddLocalizationKeyMutationFn = Apollo.MutationFunction<
  AddLocalizationKeyMutation,
  AddLocalizationKeyMutationVariables
>;

/**
 * __useAddLocalizationKeyMutation__
 *
 * To run a mutation, you first call `useAddLocalizationKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLocalizationKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLocalizationKeyMutation, { data, loading, error }] = useAddLocalizationKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLocalizationKeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddLocalizationKeyMutation,
    AddLocalizationKeyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddLocalizationKeyMutation, AddLocalizationKeyMutationVariables>(
    AddLocalizationKeyDocument,
    options
  );
}
export type AddLocalizationKeyMutationHookResult = ReturnType<typeof useAddLocalizationKeyMutation>;
export type AddLocalizationKeyMutationResult = Apollo.MutationResult<AddLocalizationKeyMutation>;
export type AddLocalizationKeyMutationOptions = Apollo.BaseMutationOptions<
  AddLocalizationKeyMutation,
  AddLocalizationKeyMutationVariables
>;
export const AddNewLanguageDocument = gql`
  mutation addNewLanguage($newLanguage: String!) {
    addNewLanguage(newLanguage: $newLanguage)
  }
`;
export type AddNewLanguageMutationFn = Apollo.MutationFunction<
  AddNewLanguageMutation,
  AddNewLanguageMutationVariables
>;

/**
 * __useAddNewLanguageMutation__
 *
 * To run a mutation, you first call `useAddNewLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNewLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNewLanguageMutation, { data, loading, error }] = useAddNewLanguageMutation({
 *   variables: {
 *      newLanguage: // value for 'newLanguage'
 *   },
 * });
 */
export function useAddNewLanguageMutation(
  baseOptions?: Apollo.MutationHookOptions<AddNewLanguageMutation, AddNewLanguageMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddNewLanguageMutation, AddNewLanguageMutationVariables>(
    AddNewLanguageDocument,
    options
  );
}
export type AddNewLanguageMutationHookResult = ReturnType<typeof useAddNewLanguageMutation>;
export type AddNewLanguageMutationResult = Apollo.MutationResult<AddNewLanguageMutation>;
export type AddNewLanguageMutationOptions = Apollo.BaseMutationOptions<
  AddNewLanguageMutation,
  AddNewLanguageMutationVariables
>;
export const GetProvidersDocument = gql`
  query getProviders($filters: InputProviderFilter) {
    providers(filters: $filters) {
      id
      createdAt
      updatedAt
      name
      apiUrl
      syncRoundEnd
      status
      retryScheduledSendCredit
      refundOnCreditFail
      filterExternalProviderBets
      isInternal
      rgsId
      configId
      games
      creditOnDisconnect
      integrationType
    }
  }
`;

/**
 * __useGetProvidersQuery__
 *
 * To run a query within a React component, call `useGetProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProvidersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetProvidersQuery(
  baseOptions?: Apollo.QueryHookOptions<GetProvidersQuery, GetProvidersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProvidersQuery, GetProvidersQueryVariables>(
    GetProvidersDocument,
    options
  );
}
export function useGetProvidersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetProvidersQuery, GetProvidersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProvidersQuery, GetProvidersQueryVariables>(
    GetProvidersDocument,
    options
  );
}
export function useGetProvidersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetProvidersQuery, GetProvidersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetProvidersQuery, GetProvidersQueryVariables>(
    GetProvidersDocument,
    options
  );
}
export type GetProvidersQueryHookResult = ReturnType<typeof useGetProvidersQuery>;
export type GetProvidersLazyQueryHookResult = ReturnType<typeof useGetProvidersLazyQuery>;
export type GetProvidersSuspenseQueryHookResult = ReturnType<typeof useGetProvidersSuspenseQuery>;
export type GetProvidersQueryResult = Apollo.QueryResult<
  GetProvidersQuery,
  GetProvidersQueryVariables
>;
export const CreateProviderDocument = gql`
  mutation createProvider($input: CreateProviderArgs!) {
    createProvider(input: $input) {
      id
      name
    }
  }
`;
export type CreateProviderMutationFn = Apollo.MutationFunction<
  CreateProviderMutation,
  CreateProviderMutationVariables
>;

/**
 * __useCreateProviderMutation__
 *
 * To run a mutation, you first call `useCreateProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProviderMutation, { data, loading, error }] = useCreateProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProviderMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateProviderMutation, CreateProviderMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateProviderMutation, CreateProviderMutationVariables>(
    CreateProviderDocument,
    options
  );
}
export type CreateProviderMutationHookResult = ReturnType<typeof useCreateProviderMutation>;
export type CreateProviderMutationResult = Apollo.MutationResult<CreateProviderMutation>;
export type CreateProviderMutationOptions = Apollo.BaseMutationOptions<
  CreateProviderMutation,
  CreateProviderMutationVariables
>;
export const GetProviderDocument = gql`
  query getProvider($providerId: String!) {
    provider(providerId: $providerId) {
      id
      createdAt
      updatedAt
      name
      apiUrl
      syncRoundEnd
      status
      retryScheduledSendCredit
      retryConfigId
      refundOnCreditFail
      filterExternalProviderBets
      isInternal
      rgsId
      configId
      games
      creditOnDisconnect
      integrationType
    }
  }
`;

/**
 * __useGetProviderQuery__
 *
 * To run a query within a React component, call `useGetProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useGetProviderQuery(
  baseOptions: Apollo.QueryHookOptions<GetProviderQuery, GetProviderQueryVariables> &
    ({ variables: GetProviderQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProviderQuery, GetProviderQueryVariables>(GetProviderDocument, options);
}
export function useGetProviderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetProviderQuery, GetProviderQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProviderQuery, GetProviderQueryVariables>(
    GetProviderDocument,
    options
  );
}
export function useGetProviderSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetProviderQuery, GetProviderQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetProviderQuery, GetProviderQueryVariables>(
    GetProviderDocument,
    options
  );
}
export type GetProviderQueryHookResult = ReturnType<typeof useGetProviderQuery>;
export type GetProviderLazyQueryHookResult = ReturnType<typeof useGetProviderLazyQuery>;
export type GetProviderSuspenseQueryHookResult = ReturnType<typeof useGetProviderSuspenseQuery>;
export type GetProviderQueryResult = Apollo.QueryResult<
  GetProviderQuery,
  GetProviderQueryVariables
>;
export const UpdateProviderDocument = gql`
  mutation updateProvider($providerId: String!, $input: UpdateProviderArgs!) {
    updateProvider(providerId: $providerId, input: $input)
  }
`;
export type UpdateProviderMutationFn = Apollo.MutationFunction<
  UpdateProviderMutation,
  UpdateProviderMutationVariables
>;

/**
 * __useUpdateProviderMutation__
 *
 * To run a mutation, you first call `useUpdateProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderMutation, { data, loading, error }] = useUpdateProviderMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProviderMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateProviderMutation, UpdateProviderMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateProviderMutation, UpdateProviderMutationVariables>(
    UpdateProviderDocument,
    options
  );
}
export type UpdateProviderMutationHookResult = ReturnType<typeof useUpdateProviderMutation>;
export type UpdateProviderMutationResult = Apollo.MutationResult<UpdateProviderMutation>;
export type UpdateProviderMutationOptions = Apollo.BaseMutationOptions<
  UpdateProviderMutation,
  UpdateProviderMutationVariables
>;
export const GetProviderConfigsDocument = gql`
  query getProviderConfigs($id: String!, $filter: ProviderConfigFilter) {
    providerConfigs(id: $id, filter: $filter) {
      id
      providerId
      createdAt
      updatedAt
      maxWin
      minBet
      maxBet
      betSuggestions
      minAutoCashout
      defaultAutoCashout
      maxAutoCashout
      defaultBet
      currency
      isRoundable
    }
  }
`;

/**
 * __useGetProviderConfigsQuery__
 *
 * To run a query within a React component, call `useGetProviderConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderConfigsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetProviderConfigsQuery(
  baseOptions: Apollo.QueryHookOptions<GetProviderConfigsQuery, GetProviderConfigsQueryVariables> &
    ({ variables: GetProviderConfigsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProviderConfigsQuery, GetProviderConfigsQueryVariables>(
    GetProviderConfigsDocument,
    options
  );
}
export function useGetProviderConfigsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProviderConfigsQuery,
    GetProviderConfigsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProviderConfigsQuery, GetProviderConfigsQueryVariables>(
    GetProviderConfigsDocument,
    options
  );
}
export function useGetProviderConfigsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetProviderConfigsQuery,
    GetProviderConfigsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetProviderConfigsQuery, GetProviderConfigsQueryVariables>(
    GetProviderConfigsDocument,
    options
  );
}
export type GetProviderConfigsQueryHookResult = ReturnType<typeof useGetProviderConfigsQuery>;
export type GetProviderConfigsLazyQueryHookResult = ReturnType<
  typeof useGetProviderConfigsLazyQuery
>;
export type GetProviderConfigsSuspenseQueryHookResult = ReturnType<
  typeof useGetProviderConfigsSuspenseQuery
>;
export type GetProviderConfigsQueryResult = Apollo.QueryResult<
  GetProviderConfigsQuery,
  GetProviderConfigsQueryVariables
>;
export const GetProviderPublicKeyDocument = gql`
  query getProviderPublicKey($providerId: String!) {
    providerPublicKey(providerId: $providerId)
  }
`;

/**
 * __useGetProviderPublicKeyQuery__
 *
 * To run a query within a React component, call `useGetProviderPublicKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderPublicKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderPublicKeyQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useGetProviderPublicKeyQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProviderPublicKeyQuery,
    GetProviderPublicKeyQueryVariables
  > &
    ({ variables: GetProviderPublicKeyQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProviderPublicKeyQuery, GetProviderPublicKeyQueryVariables>(
    GetProviderPublicKeyDocument,
    options
  );
}
export function useGetProviderPublicKeyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProviderPublicKeyQuery,
    GetProviderPublicKeyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProviderPublicKeyQuery, GetProviderPublicKeyQueryVariables>(
    GetProviderPublicKeyDocument,
    options
  );
}
export function useGetProviderPublicKeySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetProviderPublicKeyQuery,
    GetProviderPublicKeyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetProviderPublicKeyQuery, GetProviderPublicKeyQueryVariables>(
    GetProviderPublicKeyDocument,
    options
  );
}
export type GetProviderPublicKeyQueryHookResult = ReturnType<typeof useGetProviderPublicKeyQuery>;
export type GetProviderPublicKeyLazyQueryHookResult = ReturnType<
  typeof useGetProviderPublicKeyLazyQuery
>;
export type GetProviderPublicKeySuspenseQueryHookResult = ReturnType<
  typeof useGetProviderPublicKeySuspenseQuery
>;
export type GetProviderPublicKeyQueryResult = Apollo.QueryResult<
  GetProviderPublicKeyQuery,
  GetProviderPublicKeyQueryVariables
>;
export const CreateProviderConfigDocument = gql`
  mutation createProviderConfig($input: CreateProviderConfigArgs!) {
    createProviderConfig(input: $input) {
      id
    }
  }
`;
export type CreateProviderConfigMutationFn = Apollo.MutationFunction<
  CreateProviderConfigMutation,
  CreateProviderConfigMutationVariables
>;

/**
 * __useCreateProviderConfigMutation__
 *
 * To run a mutation, you first call `useCreateProviderConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProviderConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProviderConfigMutation, { data, loading, error }] = useCreateProviderConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProviderConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateProviderConfigMutation,
    CreateProviderConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateProviderConfigMutation, CreateProviderConfigMutationVariables>(
    CreateProviderConfigDocument,
    options
  );
}
export type CreateProviderConfigMutationHookResult = ReturnType<
  typeof useCreateProviderConfigMutation
>;
export type CreateProviderConfigMutationResult =
  Apollo.MutationResult<CreateProviderConfigMutation>;
export type CreateProviderConfigMutationOptions = Apollo.BaseMutationOptions<
  CreateProviderConfigMutation,
  CreateProviderConfigMutationVariables
>;
export const UpdateProviderConfigDocument = gql`
  mutation updateProviderConfig($configId: String!, $input: UpdateProviderConfigArgs!) {
    updateProviderConfig(configId: $configId, input: $input)
  }
`;
export type UpdateProviderConfigMutationFn = Apollo.MutationFunction<
  UpdateProviderConfigMutation,
  UpdateProviderConfigMutationVariables
>;

/**
 * __useUpdateProviderConfigMutation__
 *
 * To run a mutation, you first call `useUpdateProviderConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderConfigMutation, { data, loading, error }] = useUpdateProviderConfigMutation({
 *   variables: {
 *      configId: // value for 'configId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProviderConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateProviderConfigMutation,
    UpdateProviderConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateProviderConfigMutation, UpdateProviderConfigMutationVariables>(
    UpdateProviderConfigDocument,
    options
  );
}
export type UpdateProviderConfigMutationHookResult = ReturnType<
  typeof useUpdateProviderConfigMutation
>;
export type UpdateProviderConfigMutationResult =
  Apollo.MutationResult<UpdateProviderConfigMutation>;
export type UpdateProviderConfigMutationOptions = Apollo.BaseMutationOptions<
  UpdateProviderConfigMutation,
  UpdateProviderConfigMutationVariables
>;
export const DeleteProviderConfigDocument = gql`
  mutation deleteProviderConfig($configId: String!) {
    deleteProviderConfig(configId: $configId)
  }
`;
export type DeleteProviderConfigMutationFn = Apollo.MutationFunction<
  DeleteProviderConfigMutation,
  DeleteProviderConfigMutationVariables
>;

/**
 * __useDeleteProviderConfigMutation__
 *
 * To run a mutation, you first call `useDeleteProviderConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProviderConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProviderConfigMutation, { data, loading, error }] = useDeleteProviderConfigMutation({
 *   variables: {
 *      configId: // value for 'configId'
 *   },
 * });
 */
export function useDeleteProviderConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteProviderConfigMutation,
    DeleteProviderConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteProviderConfigMutation, DeleteProviderConfigMutationVariables>(
    DeleteProviderConfigDocument,
    options
  );
}
export type DeleteProviderConfigMutationHookResult = ReturnType<
  typeof useDeleteProviderConfigMutation
>;
export type DeleteProviderConfigMutationResult =
  Apollo.MutationResult<DeleteProviderConfigMutation>;
export type DeleteProviderConfigMutationOptions = Apollo.BaseMutationOptions<
  DeleteProviderConfigMutation,
  DeleteProviderConfigMutationVariables
>;
export const ExportCurrencyConfigsDocument = gql`
  query exportCurrencyConfigs($providerId: String!, $filter: ProviderConfigFilter) {
    exportCurrencyConfigs(providerId: $providerId, filter: $filter)
  }
`;

/**
 * __useExportCurrencyConfigsQuery__
 *
 * To run a query within a React component, call `useExportCurrencyConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportCurrencyConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportCurrencyConfigsQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useExportCurrencyConfigsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExportCurrencyConfigsQuery,
    ExportCurrencyConfigsQueryVariables
  > &
    ({ variables: ExportCurrencyConfigsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExportCurrencyConfigsQuery, ExportCurrencyConfigsQueryVariables>(
    ExportCurrencyConfigsDocument,
    options
  );
}
export function useExportCurrencyConfigsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExportCurrencyConfigsQuery,
    ExportCurrencyConfigsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExportCurrencyConfigsQuery, ExportCurrencyConfigsQueryVariables>(
    ExportCurrencyConfigsDocument,
    options
  );
}
export function useExportCurrencyConfigsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ExportCurrencyConfigsQuery,
    ExportCurrencyConfigsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ExportCurrencyConfigsQuery, ExportCurrencyConfigsQueryVariables>(
    ExportCurrencyConfigsDocument,
    options
  );
}
export type ExportCurrencyConfigsQueryHookResult = ReturnType<typeof useExportCurrencyConfigsQuery>;
export type ExportCurrencyConfigsLazyQueryHookResult = ReturnType<
  typeof useExportCurrencyConfigsLazyQuery
>;
export type ExportCurrencyConfigsSuspenseQueryHookResult = ReturnType<
  typeof useExportCurrencyConfigsSuspenseQuery
>;
export type ExportCurrencyConfigsQueryResult = Apollo.QueryResult<
  ExportCurrencyConfigsQuery,
  ExportCurrencyConfigsQueryVariables
>;
export const GetProvidersFromAllRgsDocument = gql`
  query getProvidersFromAllRGS {
    providersFromAllRGS {
      rgsId
      providerId
      providerName
    }
  }
`;

/**
 * __useGetProvidersFromAllRgsQuery__
 *
 * To run a query within a React component, call `useGetProvidersFromAllRgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProvidersFromAllRgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProvidersFromAllRgsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProvidersFromAllRgsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetProvidersFromAllRgsQuery,
    GetProvidersFromAllRgsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProvidersFromAllRgsQuery, GetProvidersFromAllRgsQueryVariables>(
    GetProvidersFromAllRgsDocument,
    options
  );
}
export function useGetProvidersFromAllRgsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProvidersFromAllRgsQuery,
    GetProvidersFromAllRgsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProvidersFromAllRgsQuery, GetProvidersFromAllRgsQueryVariables>(
    GetProvidersFromAllRgsDocument,
    options
  );
}
export function useGetProvidersFromAllRgsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetProvidersFromAllRgsQuery,
    GetProvidersFromAllRgsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetProvidersFromAllRgsQuery, GetProvidersFromAllRgsQueryVariables>(
    GetProvidersFromAllRgsDocument,
    options
  );
}
export type GetProvidersFromAllRgsQueryHookResult = ReturnType<
  typeof useGetProvidersFromAllRgsQuery
>;
export type GetProvidersFromAllRgsLazyQueryHookResult = ReturnType<
  typeof useGetProvidersFromAllRgsLazyQuery
>;
export type GetProvidersFromAllRgsSuspenseQueryHookResult = ReturnType<
  typeof useGetProvidersFromAllRgsSuspenseQuery
>;
export type GetProvidersFromAllRgsQueryResult = Apollo.QueryResult<
  GetProvidersFromAllRgsQuery,
  GetProvidersFromAllRgsQueryVariables
>;
export const DeleteProviderConfigIdDocument = gql`
  mutation deleteProviderConfigId($providerId: String!) {
    deleteProviderConfigId(providerId: $providerId)
  }
`;
export type DeleteProviderConfigIdMutationFn = Apollo.MutationFunction<
  DeleteProviderConfigIdMutation,
  DeleteProviderConfigIdMutationVariables
>;

/**
 * __useDeleteProviderConfigIdMutation__
 *
 * To run a mutation, you first call `useDeleteProviderConfigIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProviderConfigIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProviderConfigIdMutation, { data, loading, error }] = useDeleteProviderConfigIdMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useDeleteProviderConfigIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteProviderConfigIdMutation,
    DeleteProviderConfigIdMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteProviderConfigIdMutation,
    DeleteProviderConfigIdMutationVariables
  >(DeleteProviderConfigIdDocument, options);
}
export type DeleteProviderConfigIdMutationHookResult = ReturnType<
  typeof useDeleteProviderConfigIdMutation
>;
export type DeleteProviderConfigIdMutationResult =
  Apollo.MutationResult<DeleteProviderConfigIdMutation>;
export type DeleteProviderConfigIdMutationOptions = Apollo.BaseMutationOptions<
  DeleteProviderConfigIdMutation,
  DeleteProviderConfigIdMutationVariables
>;
export const GetRetryConfigsDocument = gql`
  query getRetryConfigs {
    retryConfigs {
      _id
      name
    }
  }
`;

/**
 * __useGetRetryConfigsQuery__
 *
 * To run a query within a React component, call `useGetRetryConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRetryConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRetryConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRetryConfigsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetRetryConfigsQuery, GetRetryConfigsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRetryConfigsQuery, GetRetryConfigsQueryVariables>(
    GetRetryConfigsDocument,
    options
  );
}
export function useGetRetryConfigsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRetryConfigsQuery, GetRetryConfigsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRetryConfigsQuery, GetRetryConfigsQueryVariables>(
    GetRetryConfigsDocument,
    options
  );
}
export function useGetRetryConfigsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetRetryConfigsQuery, GetRetryConfigsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetRetryConfigsQuery, GetRetryConfigsQueryVariables>(
    GetRetryConfigsDocument,
    options
  );
}
export type GetRetryConfigsQueryHookResult = ReturnType<typeof useGetRetryConfigsQuery>;
export type GetRetryConfigsLazyQueryHookResult = ReturnType<typeof useGetRetryConfigsLazyQuery>;
export type GetRetryConfigsSuspenseQueryHookResult = ReturnType<
  typeof useGetRetryConfigsSuspenseQuery
>;
export type GetRetryConfigsQueryResult = Apollo.QueryResult<
  GetRetryConfigsQuery,
  GetRetryConfigsQueryVariables
>;
export const CreateRaindropCampaignDocument = gql`
  mutation createRaindropCampaign($input: CreateRaindropCampaignInput!) {
    createRaindropCampaign(input: $input) {
      id
      status
      message
    }
  }
`;
export type CreateRaindropCampaignMutationFn = Apollo.MutationFunction<
  CreateRaindropCampaignMutation,
  CreateRaindropCampaignMutationVariables
>;

/**
 * __useCreateRaindropCampaignMutation__
 *
 * To run a mutation, you first call `useCreateRaindropCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRaindropCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRaindropCampaignMutation, { data, loading, error }] = useCreateRaindropCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRaindropCampaignMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateRaindropCampaignMutation,
    CreateRaindropCampaignMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateRaindropCampaignMutation,
    CreateRaindropCampaignMutationVariables
  >(CreateRaindropCampaignDocument, options);
}
export type CreateRaindropCampaignMutationHookResult = ReturnType<
  typeof useCreateRaindropCampaignMutation
>;
export type CreateRaindropCampaignMutationResult =
  Apollo.MutationResult<CreateRaindropCampaignMutation>;
export type CreateRaindropCampaignMutationOptions = Apollo.BaseMutationOptions<
  CreateRaindropCampaignMutation,
  CreateRaindropCampaignMutationVariables
>;
export const PaginatedMinesRoundsDocument = gql`
  query paginatedMinesRounds($limit: Float!, $page: Float!, $filter: InputFilterMinesRounds) {
    paginatedMinesRounds(limit: $limit, page: $page, filter: $filter) {
      total
      page
      limit
      skip
      docs {
        _id
        roundId
        playerId
        createdAt
        roundHash
        clientHash
        serverHash
      }
    }
  }
`;

/**
 * __usePaginatedMinesRoundsQuery__
 *
 * To run a query within a React component, call `usePaginatedMinesRoundsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedMinesRoundsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedMinesRoundsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePaginatedMinesRoundsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PaginatedMinesRoundsQuery,
    PaginatedMinesRoundsQueryVariables
  > &
    ({ variables: PaginatedMinesRoundsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PaginatedMinesRoundsQuery, PaginatedMinesRoundsQueryVariables>(
    PaginatedMinesRoundsDocument,
    options
  );
}
export function usePaginatedMinesRoundsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaginatedMinesRoundsQuery,
    PaginatedMinesRoundsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PaginatedMinesRoundsQuery, PaginatedMinesRoundsQueryVariables>(
    PaginatedMinesRoundsDocument,
    options
  );
}
export function usePaginatedMinesRoundsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PaginatedMinesRoundsQuery,
    PaginatedMinesRoundsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PaginatedMinesRoundsQuery, PaginatedMinesRoundsQueryVariables>(
    PaginatedMinesRoundsDocument,
    options
  );
}
export type PaginatedMinesRoundsQueryHookResult = ReturnType<typeof usePaginatedMinesRoundsQuery>;
export type PaginatedMinesRoundsLazyQueryHookResult = ReturnType<
  typeof usePaginatedMinesRoundsLazyQuery
>;
export type PaginatedMinesRoundsSuspenseQueryHookResult = ReturnType<
  typeof usePaginatedMinesRoundsSuspenseQuery
>;
export type PaginatedMinesRoundsQueryResult = Apollo.QueryResult<
  PaginatedMinesRoundsQuery,
  PaginatedMinesRoundsQueryVariables
>;
export const MinesRoundDocument = gql`
  query minesRound($roundId: String!) {
    minesRound(roundId: $roundId) {
      _id
      betAmount
      gridSize
      minesCount
      autoplay
      autobetConfig {
        numberOfBets
        payoutOnWin
        increaseOnWin
        increaseOnLoss
        stopOnProfit
        stopOnLoss
      }
      revealedTiles {
        tileNumber
        multiplier
        mine
      }
    }
  }
`;

/**
 * __useMinesRoundQuery__
 *
 * To run a query within a React component, call `useMinesRoundQuery` and pass it any options that fit your needs.
 * When your component renders, `useMinesRoundQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMinesRoundQuery({
 *   variables: {
 *      roundId: // value for 'roundId'
 *   },
 * });
 */
export function useMinesRoundQuery(
  baseOptions: Apollo.QueryHookOptions<MinesRoundQuery, MinesRoundQueryVariables> &
    ({ variables: MinesRoundQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MinesRoundQuery, MinesRoundQueryVariables>(MinesRoundDocument, options);
}
export function useMinesRoundLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MinesRoundQuery, MinesRoundQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MinesRoundQuery, MinesRoundQueryVariables>(
    MinesRoundDocument,
    options
  );
}
export function useMinesRoundSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<MinesRoundQuery, MinesRoundQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<MinesRoundQuery, MinesRoundQueryVariables>(
    MinesRoundDocument,
    options
  );
}
export type MinesRoundQueryHookResult = ReturnType<typeof useMinesRoundQuery>;
export type MinesRoundLazyQueryHookResult = ReturnType<typeof useMinesRoundLazyQuery>;
export type MinesRoundSuspenseQueryHookResult = ReturnType<typeof useMinesRoundSuspenseQuery>;
export type MinesRoundQueryResult = Apollo.QueryResult<MinesRoundQuery, MinesRoundQueryVariables>;
export const PaginatedRubberDuckRoundsDocument = gql`
  query paginatedRubberDuckRounds(
    $limit: Float!
    $page: Float!
    $filter: InputFilterRubberDuckRounds
  ) {
    paginatedRubberDuckRounds(limit: $limit, page: $page, filter: $filter) {
      total
      page
      limit
      skip
      docs {
        _id
        roundId
        playerId
        difficulty
        betAmount
        currency
        laneCount
        reachedLane
        currentMultiplier
        totalWinAmount
        status
        createdAt
      }
    }
  }
`;

/**
 * __usePaginatedRubberDuckRoundsQuery__
 *
 * To run a query within a React component, call `usePaginatedRubberDuckRoundsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedRubberDuckRoundsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedRubberDuckRoundsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePaginatedRubberDuckRoundsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PaginatedRubberDuckRoundsQuery,
    PaginatedRubberDuckRoundsQueryVariables
  > &
    ({ variables: PaginatedRubberDuckRoundsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PaginatedRubberDuckRoundsQuery, PaginatedRubberDuckRoundsQueryVariables>(
    PaginatedRubberDuckRoundsDocument,
    options
  );
}
export function usePaginatedRubberDuckRoundsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaginatedRubberDuckRoundsQuery,
    PaginatedRubberDuckRoundsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PaginatedRubberDuckRoundsQuery,
    PaginatedRubberDuckRoundsQueryVariables
  >(PaginatedRubberDuckRoundsDocument, options);
}
export function usePaginatedRubberDuckRoundsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PaginatedRubberDuckRoundsQuery,
    PaginatedRubberDuckRoundsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PaginatedRubberDuckRoundsQuery,
    PaginatedRubberDuckRoundsQueryVariables
  >(PaginatedRubberDuckRoundsDocument, options);
}
export type PaginatedRubberDuckRoundsQueryHookResult = ReturnType<
  typeof usePaginatedRubberDuckRoundsQuery
>;
export type PaginatedRubberDuckRoundsLazyQueryHookResult = ReturnType<
  typeof usePaginatedRubberDuckRoundsLazyQuery
>;
export type PaginatedRubberDuckRoundsSuspenseQueryHookResult = ReturnType<
  typeof usePaginatedRubberDuckRoundsSuspenseQuery
>;
export type PaginatedRubberDuckRoundsQueryResult = Apollo.QueryResult<
  PaginatedRubberDuckRoundsQuery,
  PaginatedRubberDuckRoundsQueryVariables
>;
export const RubberDuckRoundDocument = gql`
  query rubberDuckRound($roundId: String!) {
    rubberDuckRound(roundId: $roundId) {
      _id
      roundId
      playerId
      providerId
      gameId
      betAmount
      currency
      difficulty
      laneCount
      failLane
      reachedLane
      crossedLanes {
        lane
        multiplier
      }
      currentMultiplier
      totalWinAmount
      maxWin
      status
      autoplay
      autobetConfig {
        numberOfBets
        targetLane
        increaseOnWin
        increaseOnLoss
        stopOnProfit
        stopOnLoss
      }
      clientHash
      serverHash
      roundHash
      createdAt
      completedAt
    }
  }
`;

/**
 * __useRubberDuckRoundQuery__
 *
 * To run a query within a React component, call `useRubberDuckRoundQuery` and pass it any options that fit your needs.
 * When your component renders, `useRubberDuckRoundQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRubberDuckRoundQuery({
 *   variables: {
 *      roundId: // value for 'roundId'
 *   },
 * });
 */
export function useRubberDuckRoundQuery(
  baseOptions: Apollo.QueryHookOptions<RubberDuckRoundQuery, RubberDuckRoundQueryVariables> &
    ({ variables: RubberDuckRoundQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RubberDuckRoundQuery, RubberDuckRoundQueryVariables>(
    RubberDuckRoundDocument,
    options
  );
}
export function useRubberDuckRoundLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<RubberDuckRoundQuery, RubberDuckRoundQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RubberDuckRoundQuery, RubberDuckRoundQueryVariables>(
    RubberDuckRoundDocument,
    options
  );
}
export function useRubberDuckRoundSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<RubberDuckRoundQuery, RubberDuckRoundQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<RubberDuckRoundQuery, RubberDuckRoundQueryVariables>(
    RubberDuckRoundDocument,
    options
  );
}
export type RubberDuckRoundQueryHookResult = ReturnType<typeof useRubberDuckRoundQuery>;
export type RubberDuckRoundLazyQueryHookResult = ReturnType<typeof useRubberDuckRoundLazyQuery>;
export type RubberDuckRoundSuspenseQueryHookResult = ReturnType<
  typeof useRubberDuckRoundSuspenseQuery
>;
export type RubberDuckRoundQueryResult = Apollo.QueryResult<
  RubberDuckRoundQuery,
  RubberDuckRoundQueryVariables
>;
export const RubberDuckRoundsByPlayerDocument = gql`
  query rubberDuckRoundsByPlayer($playerId: String!, $limit: Int) {
    rubberDuckRoundsByPlayer(playerId: $playerId, limit: $limit) {
      _id
      roundId
      difficulty
      betAmount
      currency
      laneCount
      reachedLane
      currentMultiplier
      totalWinAmount
      status
      createdAt
    }
  }
`;

/**
 * __useRubberDuckRoundsByPlayerQuery__
 *
 * To run a query within a React component, call `useRubberDuckRoundsByPlayerQuery` and pass it any options that fit your needs.
 * When your component renders, `useRubberDuckRoundsByPlayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRubberDuckRoundsByPlayerQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRubberDuckRoundsByPlayerQuery(
  baseOptions: Apollo.QueryHookOptions<
    RubberDuckRoundsByPlayerQuery,
    RubberDuckRoundsByPlayerQueryVariables
  > &
    ({ variables: RubberDuckRoundsByPlayerQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RubberDuckRoundsByPlayerQuery, RubberDuckRoundsByPlayerQueryVariables>(
    RubberDuckRoundsByPlayerDocument,
    options
  );
}
export function useRubberDuckRoundsByPlayerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RubberDuckRoundsByPlayerQuery,
    RubberDuckRoundsByPlayerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<RubberDuckRoundsByPlayerQuery, RubberDuckRoundsByPlayerQueryVariables>(
    RubberDuckRoundsByPlayerDocument,
    options
  );
}
export function useRubberDuckRoundsByPlayerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RubberDuckRoundsByPlayerQuery,
    RubberDuckRoundsByPlayerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    RubberDuckRoundsByPlayerQuery,
    RubberDuckRoundsByPlayerQueryVariables
  >(RubberDuckRoundsByPlayerDocument, options);
}
export type RubberDuckRoundsByPlayerQueryHookResult = ReturnType<
  typeof useRubberDuckRoundsByPlayerQuery
>;
export type RubberDuckRoundsByPlayerLazyQueryHookResult = ReturnType<
  typeof useRubberDuckRoundsByPlayerLazyQuery
>;
export type RubberDuckRoundsByPlayerSuspenseQueryHookResult = ReturnType<
  typeof useRubberDuckRoundsByPlayerSuspenseQuery
>;
export type RubberDuckRoundsByPlayerQueryResult = Apollo.QueryResult<
  RubberDuckRoundsByPlayerQuery,
  RubberDuckRoundsByPlayerQueryVariables
>;
export const ActivePlayerRubberDuckRoundDocument = gql`
  query activePlayerRubberDuckRound($playerId: String!) {
    activePlayerRubberDuckRound(playerId: $playerId) {
      _id
      roundId
      playerId
      difficulty
      betAmount
      currency
      laneCount
      reachedLane
      currentMultiplier
      status
      createdAt
    }
  }
`;

/**
 * __useActivePlayerRubberDuckRoundQuery__
 *
 * To run a query within a React component, call `useActivePlayerRubberDuckRoundQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivePlayerRubberDuckRoundQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivePlayerRubberDuckRoundQuery({
 *   variables: {
 *      playerId: // value for 'playerId'
 *   },
 * });
 */
export function useActivePlayerRubberDuckRoundQuery(
  baseOptions: Apollo.QueryHookOptions<
    ActivePlayerRubberDuckRoundQuery,
    ActivePlayerRubberDuckRoundQueryVariables
  > &
    ({ variables: ActivePlayerRubberDuckRoundQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ActivePlayerRubberDuckRoundQuery,
    ActivePlayerRubberDuckRoundQueryVariables
  >(ActivePlayerRubberDuckRoundDocument, options);
}
export function useActivePlayerRubberDuckRoundLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActivePlayerRubberDuckRoundQuery,
    ActivePlayerRubberDuckRoundQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ActivePlayerRubberDuckRoundQuery,
    ActivePlayerRubberDuckRoundQueryVariables
  >(ActivePlayerRubberDuckRoundDocument, options);
}
export function useActivePlayerRubberDuckRoundSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ActivePlayerRubberDuckRoundQuery,
    ActivePlayerRubberDuckRoundQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ActivePlayerRubberDuckRoundQuery,
    ActivePlayerRubberDuckRoundQueryVariables
  >(ActivePlayerRubberDuckRoundDocument, options);
}
export type ActivePlayerRubberDuckRoundQueryHookResult = ReturnType<
  typeof useActivePlayerRubberDuckRoundQuery
>;
export type ActivePlayerRubberDuckRoundLazyQueryHookResult = ReturnType<
  typeof useActivePlayerRubberDuckRoundLazyQuery
>;
export type ActivePlayerRubberDuckRoundSuspenseQueryHookResult = ReturnType<
  typeof useActivePlayerRubberDuckRoundSuspenseQuery
>;
export type ActivePlayerRubberDuckRoundQueryResult = Apollo.QueryResult<
  ActivePlayerRubberDuckRoundQuery,
  ActivePlayerRubberDuckRoundQueryVariables
>;
export const TestProviderDocument = gql`
  mutation testProvider($testProviderInput: TestProvidersInput!) {
    testProvider(testProviderInput: $testProviderInput) {
      data {
        endpoint
        testCase
        errors {
          err
        }
      }
      errorsCount
      message
    }
  }
`;
export type TestProviderMutationFn = Apollo.MutationFunction<
  TestProviderMutation,
  TestProviderMutationVariables
>;

/**
 * __useTestProviderMutation__
 *
 * To run a mutation, you first call `useTestProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testProviderMutation, { data, loading, error }] = useTestProviderMutation({
 *   variables: {
 *      testProviderInput: // value for 'testProviderInput'
 *   },
 * });
 */
export function useTestProviderMutation(
  baseOptions?: Apollo.MutationHookOptions<TestProviderMutation, TestProviderMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TestProviderMutation, TestProviderMutationVariables>(
    TestProviderDocument,
    options
  );
}
export type TestProviderMutationHookResult = ReturnType<typeof useTestProviderMutation>;
export type TestProviderMutationResult = Apollo.MutationResult<TestProviderMutation>;
export type TestProviderMutationOptions = Apollo.BaseMutationOptions<
  TestProviderMutation,
  TestProviderMutationVariables
>;
export const PaginatedProviderTransactionsDocument = gql`
  query paginatedProviderTransactions(
    $limit: Float!
    $page: Float!
    $filter: InputFilterProviderTransaction!
  ) {
    paginatedProviderTransactions(limit: $limit, page: $page, filter: $filter) {
      total
      page
      limit
      skip
      docs {
        _id
        createdAt
        status
        category
        language
        currency
        roundId
        transactionId
        operation
        reason
        providerId
        playerId
        amount
        multiplier
        balance
        gameId
      }
    }
  }
`;

/**
 * __usePaginatedProviderTransactionsQuery__
 *
 * To run a query within a React component, call `usePaginatedProviderTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedProviderTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedProviderTransactionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePaginatedProviderTransactionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PaginatedProviderTransactionsQuery,
    PaginatedProviderTransactionsQueryVariables
  > &
    ({ variables: PaginatedProviderTransactionsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PaginatedProviderTransactionsQuery,
    PaginatedProviderTransactionsQueryVariables
  >(PaginatedProviderTransactionsDocument, options);
}
export function usePaginatedProviderTransactionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaginatedProviderTransactionsQuery,
    PaginatedProviderTransactionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PaginatedProviderTransactionsQuery,
    PaginatedProviderTransactionsQueryVariables
  >(PaginatedProviderTransactionsDocument, options);
}
export function usePaginatedProviderTransactionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PaginatedProviderTransactionsQuery,
    PaginatedProviderTransactionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PaginatedProviderTransactionsQuery,
    PaginatedProviderTransactionsQueryVariables
  >(PaginatedProviderTransactionsDocument, options);
}
export type PaginatedProviderTransactionsQueryHookResult = ReturnType<
  typeof usePaginatedProviderTransactionsQuery
>;
export type PaginatedProviderTransactionsLazyQueryHookResult = ReturnType<
  typeof usePaginatedProviderTransactionsLazyQuery
>;
export type PaginatedProviderTransactionsSuspenseQueryHookResult = ReturnType<
  typeof usePaginatedProviderTransactionsSuspenseQuery
>;
export type PaginatedProviderTransactionsQueryResult = Apollo.QueryResult<
  PaginatedProviderTransactionsQuery,
  PaginatedProviderTransactionsQueryVariables
>;
export const PaginatedProviderIgnoredRequestsDocument = gql`
  query paginatedProviderIgnoredRequests(
    $limit: Float!
    $page: Float!
    $filter: InputFilterIgnoredRequests!
  ) {
    paginatedProviderIgnoredRequests(limit: $limit, page: $page, filter: $filter) {
      total
      page
      limit
      skip
      docs {
        startDate
        endDate
        betId
        betAmount
      }
    }
  }
`;

/**
 * __usePaginatedProviderIgnoredRequestsQuery__
 *
 * To run a query within a React component, call `usePaginatedProviderIgnoredRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedProviderIgnoredRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedProviderIgnoredRequestsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePaginatedProviderIgnoredRequestsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PaginatedProviderIgnoredRequestsQuery,
    PaginatedProviderIgnoredRequestsQueryVariables
  > &
    (
      | { variables: PaginatedProviderIgnoredRequestsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PaginatedProviderIgnoredRequestsQuery,
    PaginatedProviderIgnoredRequestsQueryVariables
  >(PaginatedProviderIgnoredRequestsDocument, options);
}
export function usePaginatedProviderIgnoredRequestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaginatedProviderIgnoredRequestsQuery,
    PaginatedProviderIgnoredRequestsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PaginatedProviderIgnoredRequestsQuery,
    PaginatedProviderIgnoredRequestsQueryVariables
  >(PaginatedProviderIgnoredRequestsDocument, options);
}
export function usePaginatedProviderIgnoredRequestsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PaginatedProviderIgnoredRequestsQuery,
    PaginatedProviderIgnoredRequestsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PaginatedProviderIgnoredRequestsQuery,
    PaginatedProviderIgnoredRequestsQueryVariables
  >(PaginatedProviderIgnoredRequestsDocument, options);
}
export type PaginatedProviderIgnoredRequestsQueryHookResult = ReturnType<
  typeof usePaginatedProviderIgnoredRequestsQuery
>;
export type PaginatedProviderIgnoredRequestsLazyQueryHookResult = ReturnType<
  typeof usePaginatedProviderIgnoredRequestsLazyQuery
>;
export type PaginatedProviderIgnoredRequestsSuspenseQueryHookResult = ReturnType<
  typeof usePaginatedProviderIgnoredRequestsSuspenseQuery
>;
export type PaginatedProviderIgnoredRequestsQueryResult = Apollo.QueryResult<
  PaginatedProviderIgnoredRequestsQuery,
  PaginatedProviderIgnoredRequestsQueryVariables
>;
export const ProviderExportsDocument = gql`
  query providerExports {
    providerExports {
      _id
      exportType
      status
      createdAt
      finishedOn
      filename
      url
    }
  }
`;

/**
 * __useProviderExportsQuery__
 *
 * To run a query within a React component, call `useProviderExportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderExportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderExportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProviderExportsQuery(
  baseOptions?: Apollo.QueryHookOptions<ProviderExportsQuery, ProviderExportsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProviderExportsQuery, ProviderExportsQueryVariables>(
    ProviderExportsDocument,
    options
  );
}
export function useProviderExportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProviderExportsQuery, ProviderExportsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ProviderExportsQuery, ProviderExportsQueryVariables>(
    ProviderExportsDocument,
    options
  );
}
export function useProviderExportsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ProviderExportsQuery, ProviderExportsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ProviderExportsQuery, ProviderExportsQueryVariables>(
    ProviderExportsDocument,
    options
  );
}
export type ProviderExportsQueryHookResult = ReturnType<typeof useProviderExportsQuery>;
export type ProviderExportsLazyQueryHookResult = ReturnType<typeof useProviderExportsLazyQuery>;
export type ProviderExportsSuspenseQueryHookResult = ReturnType<
  typeof useProviderExportsSuspenseQuery
>;
export type ProviderExportsQueryResult = Apollo.QueryResult<
  ProviderExportsQuery,
  ProviderExportsQueryVariables
>;
export const ExportTransactionsToExcelDocument = gql`
  mutation exportTransactionsToExcel($input: ExportExcelInput!) {
    exportTransactionsToExcel(input: $input) {
      status
      exportId
    }
  }
`;
export type ExportTransactionsToExcelMutationFn = Apollo.MutationFunction<
  ExportTransactionsToExcelMutation,
  ExportTransactionsToExcelMutationVariables
>;

/**
 * __useExportTransactionsToExcelMutation__
 *
 * To run a mutation, you first call `useExportTransactionsToExcelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportTransactionsToExcelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportTransactionsToExcelMutation, { data, loading, error }] = useExportTransactionsToExcelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportTransactionsToExcelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExportTransactionsToExcelMutation,
    ExportTransactionsToExcelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ExportTransactionsToExcelMutation,
    ExportTransactionsToExcelMutationVariables
  >(ExportTransactionsToExcelDocument, options);
}
export type ExportTransactionsToExcelMutationHookResult = ReturnType<
  typeof useExportTransactionsToExcelMutation
>;
export type ExportTransactionsToExcelMutationResult =
  Apollo.MutationResult<ExportTransactionsToExcelMutation>;
export type ExportTransactionsToExcelMutationOptions = Apollo.BaseMutationOptions<
  ExportTransactionsToExcelMutation,
  ExportTransactionsToExcelMutationVariables
>;
export const GetUsersDocument = gql`
  query getUsers {
    users {
      id
      email
      providerId
      roleIds
      providerRgs {
        rgsId
        providerIds
      }
      games
    }
  }
`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
}
export function useGetUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
}
export function useGetUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
}
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetUserDocument = gql`
  query getUser($id: String!) {
    user(id: $id) {
      id
      email
      providerId
      roleIds
      providerRgs {
        rgsId
        providerIds
      }
      games
    }
  }
`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(
  baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables> &
    ({ variables: GetUserQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
}
export function useGetUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
}
export function useGetUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
}
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetRolesDocument = gql`
  query getRoles {
    roles {
      id
      name
      description
      permissions
      isEditable
    }
  }
`;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRolesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetRolesQuery, GetRolesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
}
export function useGetRolesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
}
export function useGetRolesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
}
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesSuspenseQueryHookResult = ReturnType<typeof useGetRolesSuspenseQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<GetRolesQuery, GetRolesQueryVariables>;
export const GetRoleDocument = gql`
  query getRole($id: String!) {
    role(id: $id) {
      id
      name
      description
      permissions
    }
  }
`;

/**
 * __useGetRoleQuery__
 *
 * To run a query within a React component, call `useGetRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRoleQuery(
  baseOptions: Apollo.QueryHookOptions<GetRoleQuery, GetRoleQueryVariables> &
    ({ variables: GetRoleQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
}
export function useGetRoleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
}
export function useGetRoleSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
}
export type GetRoleQueryHookResult = ReturnType<typeof useGetRoleQuery>;
export type GetRoleLazyQueryHookResult = ReturnType<typeof useGetRoleLazyQuery>;
export type GetRoleSuspenseQueryHookResult = ReturnType<typeof useGetRoleSuspenseQuery>;
export type GetRoleQueryResult = Apollo.QueryResult<GetRoleQuery, GetRoleQueryVariables>;
export const GetPermissionsDocument = gql`
  query getPermissions {
    permissions
  }
`;

/**
 * __useGetPermissionsQuery__
 *
 * To run a query within a React component, call `useGetPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPermissionsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(
    GetPermissionsDocument,
    options
  );
}
export function useGetPermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(
    GetPermissionsDocument,
    options
  );
}
export function useGetPermissionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(
    GetPermissionsDocument,
    options
  );
}
export type GetPermissionsQueryHookResult = ReturnType<typeof useGetPermissionsQuery>;
export type GetPermissionsLazyQueryHookResult = ReturnType<typeof useGetPermissionsLazyQuery>;
export type GetPermissionsSuspenseQueryHookResult = ReturnType<
  typeof useGetPermissionsSuspenseQuery
>;
export type GetPermissionsQueryResult = Apollo.QueryResult<
  GetPermissionsQuery,
  GetPermissionsQueryVariables
>;
export const CreateRoleDocument = gql`
  mutation createRole($input: InputCreateRole!) {
    createRole(input: $input) {
      id
    }
  }
`;
export type CreateRoleMutationFn = Apollo.MutationFunction<
  CreateRoleMutation,
  CreateRoleMutationVariables
>;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleMutation, { data, loading, error }] = useCreateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateRoleMutation, CreateRoleMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(
    CreateRoleDocument,
    options
  );
}
export type CreateRoleMutationHookResult = ReturnType<typeof useCreateRoleMutation>;
export type CreateRoleMutationResult = Apollo.MutationResult<CreateRoleMutation>;
export type CreateRoleMutationOptions = Apollo.BaseMutationOptions<
  CreateRoleMutation,
  CreateRoleMutationVariables
>;
export const CreateUserDocument = gql`
  mutation createUser($input: InputCreateUser!) {
    createUser(input: $input) {
      id
    }
  }
`;
export type CreateUserMutationFn = Apollo.MutationFunction<
  CreateUserMutation,
  CreateUserMutationVariables
>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(
    CreateUserDocument,
    options
  );
}
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<
  CreateUserMutation,
  CreateUserMutationVariables
>;
export const DeleteRoleDocument = gql`
  mutation deleteRole($input: InputDeleteRole!) {
    deleteRole(input: $input)
  }
`;
export type DeleteRoleMutationFn = Apollo.MutationFunction<
  DeleteRoleMutation,
  DeleteRoleMutationVariables
>;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteRoleMutation, DeleteRoleMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(
    DeleteRoleDocument,
    options
  );
}
export type DeleteRoleMutationHookResult = ReturnType<typeof useDeleteRoleMutation>;
export type DeleteRoleMutationResult = Apollo.MutationResult<DeleteRoleMutation>;
export type DeleteRoleMutationOptions = Apollo.BaseMutationOptions<
  DeleteRoleMutation,
  DeleteRoleMutationVariables
>;
export const GetSessionDocument = gql`
  query getSession {
    session {
      provider {
        id
        name
        games
      }
      session {
        id
        email
        providerIds
        permissions
        isSuper
        rgsIds
      }
    }
  }
`;

/**
 * __useGetSessionQuery__
 *
 * To run a query within a React component, call `useGetSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSessionQuery(
  baseOptions?: Apollo.QueryHookOptions<GetSessionQuery, GetSessionQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSessionQuery, GetSessionQueryVariables>(GetSessionDocument, options);
}
export function useGetSessionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSessionQuery, GetSessionQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSessionQuery, GetSessionQueryVariables>(
    GetSessionDocument,
    options
  );
}
export function useGetSessionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetSessionQuery, GetSessionQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSessionQuery, GetSessionQueryVariables>(
    GetSessionDocument,
    options
  );
}
export type GetSessionQueryHookResult = ReturnType<typeof useGetSessionQuery>;
export type GetSessionLazyQueryHookResult = ReturnType<typeof useGetSessionLazyQuery>;
export type GetSessionSuspenseQueryHookResult = ReturnType<typeof useGetSessionSuspenseQuery>;
export type GetSessionQueryResult = Apollo.QueryResult<GetSessionQuery, GetSessionQueryVariables>;
export const SignInDocument = gql`
  mutation signIn($email: String!, $password: String!) {
    signIn(email: $email, password: $password) {
      accessToken
      refreshToken
    }
  }
`;
export type SignInMutationFn = Apollo.MutationFunction<SignInMutation, SignInMutationVariables>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSignInMutation(
  baseOptions?: Apollo.MutationHookOptions<SignInMutation, SignInMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
}
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutation>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<
  SignInMutation,
  SignInMutationVariables
>;
export const RefreshTokenDocument = gql`
  mutation refreshToken($token: String!) {
    refreshToken(token: $token) {
      accessToken
      refreshToken
    }
  }
`;
export type RefreshTokenMutationFn = Apollo.MutationFunction<
  RefreshTokenMutation,
  RefreshTokenMutationVariables
>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRefreshTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(
    RefreshTokenDocument,
    options
  );
}
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<
  RefreshTokenMutation,
  RefreshTokenMutationVariables
>;
export const CreateAviatorPermissionDocument = gql`
  mutation createAviatorPermission($permission: String!) {
    addPermission(permission: $permission)
  }
`;
export type CreateAviatorPermissionMutationFn = Apollo.MutationFunction<
  CreateAviatorPermissionMutation,
  CreateAviatorPermissionMutationVariables
>;

/**
 * __useCreateAviatorPermissionMutation__
 *
 * To run a mutation, you first call `useCreateAviatorPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAviatorPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAviatorPermissionMutation, { data, loading, error }] = useCreateAviatorPermissionMutation({
 *   variables: {
 *      permission: // value for 'permission'
 *   },
 * });
 */
export function useCreateAviatorPermissionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAviatorPermissionMutation,
    CreateAviatorPermissionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAviatorPermissionMutation,
    CreateAviatorPermissionMutationVariables
  >(CreateAviatorPermissionDocument, options);
}
export type CreateAviatorPermissionMutationHookResult = ReturnType<
  typeof useCreateAviatorPermissionMutation
>;
export type CreateAviatorPermissionMutationResult =
  Apollo.MutationResult<CreateAviatorPermissionMutation>;
export type CreateAviatorPermissionMutationOptions = Apollo.BaseMutationOptions<
  CreateAviatorPermissionMutation,
  CreateAviatorPermissionMutationVariables
>;
export const DeleteSelectedRolePermissionDocument = gql`
  mutation deleteSelectedRolePermission($input: InputRemoveRolePermission!) {
    removeRolePermission(input: $input)
  }
`;
export type DeleteSelectedRolePermissionMutationFn = Apollo.MutationFunction<
  DeleteSelectedRolePermissionMutation,
  DeleteSelectedRolePermissionMutationVariables
>;

/**
 * __useDeleteSelectedRolePermissionMutation__
 *
 * To run a mutation, you first call `useDeleteSelectedRolePermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSelectedRolePermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSelectedRolePermissionMutation, { data, loading, error }] = useDeleteSelectedRolePermissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSelectedRolePermissionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteSelectedRolePermissionMutation,
    DeleteSelectedRolePermissionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteSelectedRolePermissionMutation,
    DeleteSelectedRolePermissionMutationVariables
  >(DeleteSelectedRolePermissionDocument, options);
}
export type DeleteSelectedRolePermissionMutationHookResult = ReturnType<
  typeof useDeleteSelectedRolePermissionMutation
>;
export type DeleteSelectedRolePermissionMutationResult =
  Apollo.MutationResult<DeleteSelectedRolePermissionMutation>;
export type DeleteSelectedRolePermissionMutationOptions = Apollo.BaseMutationOptions<
  DeleteSelectedRolePermissionMutation,
  DeleteSelectedRolePermissionMutationVariables
>;
export const AssignRolePermissionsDocument = gql`
  mutation assignRolePermissions($input: InputAssignRolePermissions!) {
    assignRolePermissions(input: $input)
  }
`;
export type AssignRolePermissionsMutationFn = Apollo.MutationFunction<
  AssignRolePermissionsMutation,
  AssignRolePermissionsMutationVariables
>;

/**
 * __useAssignRolePermissionsMutation__
 *
 * To run a mutation, you first call `useAssignRolePermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignRolePermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignRolePermissionsMutation, { data, loading, error }] = useAssignRolePermissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignRolePermissionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignRolePermissionsMutation,
    AssignRolePermissionsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AssignRolePermissionsMutation, AssignRolePermissionsMutationVariables>(
    AssignRolePermissionsDocument,
    options
  );
}
export type AssignRolePermissionsMutationHookResult = ReturnType<
  typeof useAssignRolePermissionsMutation
>;
export type AssignRolePermissionsMutationResult =
  Apollo.MutationResult<AssignRolePermissionsMutation>;
export type AssignRolePermissionsMutationOptions = Apollo.BaseMutationOptions<
  AssignRolePermissionsMutation,
  AssignRolePermissionsMutationVariables
>;
export const LogoutDocument = gql`
  mutation logout {
    logout
  }
`;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(
  baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
}
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<
  LogoutMutation,
  LogoutMutationVariables
>;
